/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const EntityBankAccountFragmentFragmentDoc = gql`
    fragment EntityBankAccountFragment on AccountObjectType {
  name
  id
  bankAccount {
    id
    bankName
    bankInfoRedacted
    ownerName
    achCompanyIdPresent
    paymentCapabilities {
      wirePayments
      achPayments
      supportedPaymentMethods
    }
  }
}
    `;
export const DetailedPayeeLogFragmentDoc = gql`
    fragment DetailedPayeeLog on PayeeLog {
  id
  eventType
  status
  previousStatus
  user {
    id
    firstName
    lastName
    fullName
  }
  reason
  dateTime
}
    `;
export const PayeeFragmentDoc = gql`
    fragment Payee on PayeeObjectType {
  id
  name
  payeeType
}
    `;
export const FederatedCreatePaymentPrefFragmentFragmentDoc = gql`
    fragment FederatedCreatePaymentPrefFragment on PaymentPrefObjectType {
  id
}
    `;
export const CountryFullFragmentDoc = gql`
    fragment CountryFull on CountryObjectType {
  alpha2code
  code
  id
  name
}
    `;
export const StateFullFragmentDoc = gql`
    fragment StateFull on StateObjectType {
  code
  id
  name
}
    `;
export const AchPaymentPrefFullFragmentDoc = gql`
    fragment AchPaymentPrefFull on AchPaymentPrefObjectType {
  id
  paymentPrefId
  accountHolderType
  accountName
  accountNumber
  accountOwnership
  accountType
  additionalInstructions
  bankInfoRedacted
  bankName
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  paymentMethod
  routingNumber
  signatureFullName
}
    `;
export const SubscriptionAddressFullFragmentDoc = gql`
    fragment SubscriptionAddressFull on SubscriptionAddressObjectType {
  city
  country {
    ...CountryFull
  }
  postalCode
  region
  state {
    ...StateFull
  }
  street
  street2
  street3
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const WireBankFullFragmentDoc = gql`
    fragment WireBankFull on WireBankObjectType {
  abaNumber
  address {
    ...SubscriptionAddressFull
  }
  intlRoutingCode
  name
  swiftCode
}
    ${SubscriptionAddressFullFragmentDoc}`;
export const WireExtraFieldFullFragmentDoc = gql`
    fragment WireExtraFieldFull on WireExtraFieldObjectType {
  field0
  field1
  field2
  field3
}
    `;
export const WirePaymentPrefFullFragmentDoc = gql`
    fragment WirePaymentPrefFull on WirePaymentPrefObjectType {
  id
  paymentPrefId
  bank {
    ...WireBankFull
  }
  bankInfoRedacted
  beneficiaryAccountNumber
  beneficiaryAddress {
    ...SubscriptionAddressFull
  }
  beneficiaryName
  beneficiaryType
  intermediaryBank {
    ...WireBankFull
  }
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  paymentMethod
  referenceToBeneficiary
  wireBbi {
    ...WireExtraFieldFull
  }
  wireObi {
    ...WireExtraFieldFull
  }
}
    ${WireBankFullFragmentDoc}
${SubscriptionAddressFullFragmentDoc}
${WireExtraFieldFullFragmentDoc}`;
export const CheckPaymentPrefFullFragmentDoc = gql`
    fragment CheckPaymentPrefFull on CheckPaymentPrefObjectType {
  id
  paymentPrefId
  accountHolderType
  address {
    ...SubscriptionAddressFull
  }
  bankCountry {
    ...CountryFull
  }
  bankName
  memo
  naturalPersonDateOfBirth
  naturalPersonEmailAddress
  naturalPersonFirstName
  naturalPersonLastName
  naturalPersonMiddleName
  payeeName
  paymentMethod
  useAccountMailingAddress
  bankInfoRedacted
}
    ${SubscriptionAddressFullFragmentDoc}
${CountryFullFragmentDoc}`;
export const PaymentPrefAddressFullFragmentDoc = gql`
    fragment PaymentPrefAddressFull on PaymentPrefAddressObjectType {
  city
  country {
    ...CountryFull
  }
  postalCode
  region
  state {
    ...StateFull
  }
  street
  street2
  street3
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const BecsPaymentPrefFullFragmentDoc = gql`
    fragment BecsPaymentPrefFull on BecsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  accountName
  accountNumber
  bank {
    bsb
    name
    address {
      ...PaymentPrefAddressFull
    }
  }
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    city
    country {
      ...CountryFull
    }
    postalCode
    region
    state {
      ...StateFull
    }
    street
    street2
    street3
  }
}
    ${PaymentPrefAddressFullFragmentDoc}
${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const EftBankFullFragmentDoc = gql`
    fragment EftBankFull on EftBankObjectType {
  name
  institutionNumber
  transitNumber
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const EftPaymentPrefFullFragmentDoc = gql`
    fragment EftPaymentPrefFull on EftPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...EftBankFull
  }
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${EftBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const BacsPaymentPrefFullFragmentDoc = gql`
    fragment BacsPaymentPrefFull on BacsPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  accountName
  accountNumber
  additionalInstructions
  bankInfoRedacted
  bank {
    name
    sortCode
    address {
      city
      country {
        ...CountryFull
      }
      postalCode
      region
      state {
        ...StateFull
      }
      street
      street2
      street3
    }
  }
  accountHolderAddress {
    city
    country {
      ...CountryFull
    }
    postalCode
    region
    state {
      ...StateFull
    }
    street
    street2
    street3
  }
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}`;
export const SepaBankFullFragmentDoc = gql`
    fragment SepaBankFull on SepaBankObjectType {
  name
  bicSwiftCode
  address {
    ...PaymentPrefAddressFull
  }
}
    ${PaymentPrefAddressFullFragmentDoc}`;
export const SepaPaymentPrefFullFragmentDoc = gql`
    fragment SepaPaymentPrefFull on SepaPaymentPrefObjectType {
  id
  paymentPrefId
  paymentMethod
  bank {
    ...SepaBankFull
  }
  accountName
  iban
  additionalInstructions
  bankInfoRedacted
  accountHolderAddress {
    ...PaymentPrefAddressFull
  }
}
    ${SepaBankFullFragmentDoc}
${PaymentPrefAddressFullFragmentDoc}`;
export const DetailedPaymentPrefFragmentDoc = gql`
    fragment DetailedPaymentPref on PaymentPrefObjectType {
  id
  paymentMethod
  checkAddrCity
  checkAddrCountry {
    ...CountryFull
  }
  checkAddrCountryId
  checkAddrPostalCode
  checkAddrRegion
  checkAddrState {
    ...StateFull
  }
  checkAddrStateId
  checkAddrStreet
  checkAddrStreet2
  checkAddrStreet3
  checkMailingAddressSameAsAccount
  checkMemoField
  checkPayeeOverride
  verificationStatus
  returnCode
  codeReason
  nocCorrections {
    paymentId
    nocCode
    receivedAt
    corrections {
      accountNumberSafe
      routingNumber
      transactionCode
    }
  }
  wireHasIntermediary
  wireHasInternationalBeneficiaryAddress
  watchlistStatus {
    id
    status
    name
    investorDiligenceType
    arenaId
  }
  paymentPrefFull {
    __typename
    ... on AchPaymentPrefObjectType {
      ...AchPaymentPrefFull
    }
    ... on WirePaymentPrefObjectType {
      ...WirePaymentPrefFull
    }
    ... on CheckPaymentPrefObjectType {
      ...CheckPaymentPrefFull
    }
    ... on BecsPaymentPrefObjectType {
      ...BecsPaymentPrefFull
    }
    ... on EftPaymentPrefObjectType {
      ...EftPaymentPrefFull
    }
    ... on BacsPaymentPrefObjectType {
      ...BacsPaymentPrefFull
    }
    ... on SepaPaymentPrefObjectType {
      ...SepaPaymentPrefFull
    }
    ... on NonUsPaymentPrefObjectType {
      id
      paymentPrefId
      paymentMethod
      nonUsPaymentPrefInstructions
      otherPaymentPrefLabel
    }
  }
}
    ${CountryFullFragmentDoc}
${StateFullFragmentDoc}
${AchPaymentPrefFullFragmentDoc}
${WirePaymentPrefFullFragmentDoc}
${CheckPaymentPrefFullFragmentDoc}
${BecsPaymentPrefFullFragmentDoc}
${EftPaymentPrefFullFragmentDoc}
${BacsPaymentPrefFullFragmentDoc}
${SepaPaymentPrefFullFragmentDoc}`;
export const RedactedPaymentPrefFragmentDoc = gql`
    fragment RedactedPaymentPref on PaymentPrefObjectType {
  id
  verificationStatus
  paymentMethod
  bankInfoRedacted
  returnCode
  codeReason
  nocCorrections {
    paymentId
    nocCode
    receivedAt
    corrections {
      accountNumberSafe
      routingNumber
      transactionCode
    }
  }
}
    `;
export const CompatibilityWithPositionsFragmentDoc = gql`
    fragment CompatibilityWithPositions on PaymentPrefObjectType {
  compatibilityWithPositions(
    positionId: $positionId
    accountIds: $accountIds
    paymentPrefIds: $paymentPrefIds
  ) {
    isCompatible
    supportedPositionIds
  }
}
    `;
export const DetailedPaymentBatchLogFragmentDoc = gql`
    fragment DetailedPaymentBatchLog on PaymentBatchLog {
  id
  eventType
  status
  user {
    id
    firstName
    lastName
    fullName
  }
  reason
  dateTime
  reviewStatus
  reviewUser {
    id
    firstName
    lastName
    fullName
  }
  actionType
}
    `;
export const GetCountryCodesDocument = gql`
    query GetCountryCodes {
  countries {
    edges {
      node {
        id
        code
        alpha2code
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountryCodesQuery__
 *
 * To run a query within a React component, call `useGetCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
      }
export function useGetCountryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
        }
// @ts-ignore
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>;
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCountryCodesQuery | undefined, GraphqlTypes.GetCountryCodesQueryVariables>;
export function useGetCountryCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>(GetCountryCodesDocument, options);
        }
export type GetCountryCodesQueryHookResult = ReturnType<typeof useGetCountryCodesQuery>;
export type GetCountryCodesLazyQueryHookResult = ReturnType<typeof useGetCountryCodesLazyQuery>;
export type GetCountryCodesSuspenseQueryHookResult = ReturnType<typeof useGetCountryCodesSuspenseQuery>;
export type GetCountryCodesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCountryCodesQuery, GraphqlTypes.GetCountryCodesQueryVariables>;
export const MapBankAccountToEntityOperationDocument = gql`
    mutation MapBankAccountToEntityOperation($bankAccountId: ID!, $entityId: ID!, $arenaId: ID!) {
  mapBankAccountToEntity(
    bankAccountId: $bankAccountId
    entityId: $entityId
    arenaId: $arenaId
  ) {
    success
    errorMessage
    mapping {
      id
      bankAccountId
      accountId
      createdAt
      modifiedAt
    }
  }
}
    `;
export type MapBankAccountToEntityOperationMutationFn = Apollo.MutationFunction<GraphqlTypes.MapBankAccountToEntityOperationMutation, GraphqlTypes.MapBankAccountToEntityOperationMutationVariables>;

/**
 * __useMapBankAccountToEntityOperationMutation__
 *
 * To run a mutation, you first call `useMapBankAccountToEntityOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMapBankAccountToEntityOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mapBankAccountToEntityOperationMutation, { data, loading, error }] = useMapBankAccountToEntityOperationMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      entityId: // value for 'entityId'
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useMapBankAccountToEntityOperationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MapBankAccountToEntityOperationMutation, GraphqlTypes.MapBankAccountToEntityOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MapBankAccountToEntityOperationMutation, GraphqlTypes.MapBankAccountToEntityOperationMutationVariables>(MapBankAccountToEntityOperationDocument, options);
      }
export type MapBankAccountToEntityOperationMutationHookResult = ReturnType<typeof useMapBankAccountToEntityOperationMutation>;
export type MapBankAccountToEntityOperationMutationResult = Apollo.MutationResult<GraphqlTypes.MapBankAccountToEntityOperationMutation>;
export type MapBankAccountToEntityOperationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MapBankAccountToEntityOperationMutation, GraphqlTypes.MapBankAccountToEntityOperationMutationVariables>;
export const ConfigureBankAccountDocument = gql`
    mutation ConfigureBankAccount($configureBankAccountInput: ConfigureBankAccountInput!) {
  configureBankAccount(configureBankAccountInput: $configureBankAccountInput) {
    success
    errors {
      field
      message
    }
  }
}
    `;
export type ConfigureBankAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfigureBankAccountMutation, GraphqlTypes.ConfigureBankAccountMutationVariables>;

/**
 * __useConfigureBankAccountMutation__
 *
 * To run a mutation, you first call `useConfigureBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureBankAccountMutation, { data, loading, error }] = useConfigureBankAccountMutation({
 *   variables: {
 *      configureBankAccountInput: // value for 'configureBankAccountInput'
 *   },
 * });
 */
export function useConfigureBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfigureBankAccountMutation, GraphqlTypes.ConfigureBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfigureBankAccountMutation, GraphqlTypes.ConfigureBankAccountMutationVariables>(ConfigureBankAccountDocument, options);
      }
export type ConfigureBankAccountMutationHookResult = ReturnType<typeof useConfigureBankAccountMutation>;
export type ConfigureBankAccountMutationResult = Apollo.MutationResult<GraphqlTypes.ConfigureBankAccountMutation>;
export type ConfigureBankAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfigureBankAccountMutation, GraphqlTypes.ConfigureBankAccountMutationVariables>;
export const GeneratePresignedUrlsDocument = gql`
    mutation generatePresignedUrls($urlGeneratorInput: [PresignedUrlInput!]!) {
  generatePresignedUrls(urlGeneratorInput: $urlGeneratorInput) {
    presignedUrlObjs {
      s3Url
      objectKey
      fileName
    }
  }
}
    `;
export type GeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;

/**
 * __useGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedUrlsMutation, { data, loading, error }] = useGeneratePresignedUrlsMutation({
 *   variables: {
 *      urlGeneratorInput: // value for 'urlGeneratorInput'
 *   },
 * });
 */
export function useGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>(GeneratePresignedUrlsDocument, options);
      }
export type GeneratePresignedUrlsMutationHookResult = ReturnType<typeof useGeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.GeneratePresignedUrlsMutation>;
export type GeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.GeneratePresignedUrlsMutation, GraphqlTypes.GeneratePresignedUrlsMutationVariables>;
export const GetAccountingPayableForSlideoutDocument = gql`
    query GetAccountingPayableForSlideout($id: ID!) {
  accountingPayable(id: $id) {
    id
    objectType
    label
    subtitleLabel
    description
    date
    totalAmountPayable {
      monies
    }
    amountMarkedPaid {
      monies
    }
    isPaymentRequested
    requestedPaymentDate
    payeeCount
    amountPaidViaAutomatedPayments
    paymentBatches {
      id
      createdAt
      objectsCount
      netAmount
      status
      payments {
        objectId
        status
        method
        amount
        scheduledProcessDate
      }
      creatorId
    }
    arena {
      id
      name
      jsqHostname
    }
    entity {
      id
      name
    }
    entityId
    arenaId
    payees {
      position {
        id
        account {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountingPayableForSlideoutQuery__
 *
 * To run a query within a React component, call `useGetAccountingPayableForSlideoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingPayableForSlideoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingPayableForSlideoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountingPayableForSlideoutQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables> & ({ variables: GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>(GetAccountingPayableForSlideoutDocument, options);
      }
export function useGetAccountingPayableForSlideoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>(GetAccountingPayableForSlideoutDocument, options);
        }
// @ts-ignore
export function useGetAccountingPayableForSlideoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>;
export function useGetAccountingPayableForSlideoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayableForSlideoutQuery | undefined, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>;
export function useGetAccountingPayableForSlideoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>(GetAccountingPayableForSlideoutDocument, options);
        }
export type GetAccountingPayableForSlideoutQueryHookResult = ReturnType<typeof useGetAccountingPayableForSlideoutQuery>;
export type GetAccountingPayableForSlideoutLazyQueryHookResult = ReturnType<typeof useGetAccountingPayableForSlideoutLazyQuery>;
export type GetAccountingPayableForSlideoutSuspenseQueryHookResult = ReturnType<typeof useGetAccountingPayableForSlideoutSuspenseQuery>;
export type GetAccountingPayableForSlideoutQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountingPayableForSlideoutQuery, GraphqlTypes.GetAccountingPayableForSlideoutQueryVariables>;
export const GetBankAccountsForConfigurationDocument = gql`
    query GetBankAccountsForConfiguration($arenaId: Int!, $first: Int, $after: String) {
  bankAccountsConnection(arenaId: $arenaId, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        bankAccountName
        bankName
        bankInfoRedacted
        investmentEntities {
          id
          name
        }
        mappedInvestmentEntities {
          id
          name
        }
        providers {
          providerId
          providerName
          bankSource
        }
        verifications {
          providerId
          verificationStatus
        }
        configurations {
          providerCapabilityId
          fundRecsExportStatus
          fundRecsUdf
        }
      }
    }
  }
}
    `;

/**
 * __useGetBankAccountsForConfigurationQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsForConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsForConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsForConfigurationQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBankAccountsForConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables> & ({ variables: GraphqlTypes.GetBankAccountsForConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>(GetBankAccountsForConfigurationDocument, options);
      }
export function useGetBankAccountsForConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>(GetBankAccountsForConfigurationDocument, options);
        }
// @ts-ignore
export function useGetBankAccountsForConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>;
export function useGetBankAccountsForConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetBankAccountsForConfigurationQuery | undefined, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>;
export function useGetBankAccountsForConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>(GetBankAccountsForConfigurationDocument, options);
        }
export type GetBankAccountsForConfigurationQueryHookResult = ReturnType<typeof useGetBankAccountsForConfigurationQuery>;
export type GetBankAccountsForConfigurationLazyQueryHookResult = ReturnType<typeof useGetBankAccountsForConfigurationLazyQuery>;
export type GetBankAccountsForConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetBankAccountsForConfigurationSuspenseQuery>;
export type GetBankAccountsForConfigurationQueryResult = Apollo.QueryResult<GraphqlTypes.GetBankAccountsForConfigurationQuery, GraphqlTypes.GetBankAccountsForConfigurationQueryVariables>;
export const GetEntityCountryAndCurrencyDocument = gql`
    query GetEntityCountryAndCurrency($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    currency {
      code
    }
    domicileAddress {
      country {
        objectName
        objectId
      }
    }
  }
}
    `;

/**
 * __useGetEntityCountryAndCurrencyQuery__
 *
 * To run a query within a React component, call `useGetEntityCountryAndCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityCountryAndCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityCountryAndCurrencyQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityCountryAndCurrencyQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables> & ({ variables: GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>(GetEntityCountryAndCurrencyDocument, options);
      }
export function useGetEntityCountryAndCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>(GetEntityCountryAndCurrencyDocument, options);
        }
// @ts-ignore
export function useGetEntityCountryAndCurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>;
export function useGetEntityCountryAndCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityCountryAndCurrencyQuery | undefined, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>;
export function useGetEntityCountryAndCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>(GetEntityCountryAndCurrencyDocument, options);
        }
export type GetEntityCountryAndCurrencyQueryHookResult = ReturnType<typeof useGetEntityCountryAndCurrencyQuery>;
export type GetEntityCountryAndCurrencyLazyQueryHookResult = ReturnType<typeof useGetEntityCountryAndCurrencyLazyQuery>;
export type GetEntityCountryAndCurrencySuspenseQueryHookResult = ReturnType<typeof useGetEntityCountryAndCurrencySuspenseQuery>;
export type GetEntityCountryAndCurrencyQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityCountryAndCurrencyQuery, GraphqlTypes.GetEntityCountryAndCurrencyQueryVariables>;
export const CurrentArenaDocument = gql`
    query CurrentArena {
  session {
    arenaId
  }
}
    `;

/**
 * __useCurrentArenaQuery__
 *
 * To run a query within a React component, call `useCurrentArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentArenaQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>(CurrentArenaDocument, options);
      }
export function useCurrentArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>(CurrentArenaDocument, options);
        }
// @ts-ignore
export function useCurrentArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>;
export function useCurrentArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CurrentArenaQuery | undefined, GraphqlTypes.CurrentArenaQueryVariables>;
export function useCurrentArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>(CurrentArenaDocument, options);
        }
export type CurrentArenaQueryHookResult = ReturnType<typeof useCurrentArenaQuery>;
export type CurrentArenaLazyQueryHookResult = ReturnType<typeof useCurrentArenaLazyQuery>;
export type CurrentArenaSuspenseQueryHookResult = ReturnType<typeof useCurrentArenaSuspenseQuery>;
export type CurrentArenaQueryResult = Apollo.QueryResult<GraphqlTypes.CurrentArenaQuery, GraphqlTypes.CurrentArenaQueryVariables>;
export const CashInsightsDocument = gql`
    query CashInsights($arenaId: ID!, $limit: Int!) {
  liquidityDashboardCashInsights(arenaId: $arenaId, limit: $limit) {
    id
    cardKind
    headline
    rationale
    entityId
    entityName
    bankAccountId
    bankAccountName
    asOfDate
    generatedAt
    modelId
  }
}
    `;

/**
 * __useCashInsightsQuery__
 *
 * To run a query within a React component, call `useCashInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashInsightsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCashInsightsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables> & ({ variables: GraphqlTypes.CashInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>(CashInsightsDocument, options);
      }
export function useCashInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>(CashInsightsDocument, options);
        }
// @ts-ignore
export function useCashInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>;
export function useCashInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CashInsightsQuery | undefined, GraphqlTypes.CashInsightsQueryVariables>;
export function useCashInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>(CashInsightsDocument, options);
        }
export type CashInsightsQueryHookResult = ReturnType<typeof useCashInsightsQuery>;
export type CashInsightsLazyQueryHookResult = ReturnType<typeof useCashInsightsLazyQuery>;
export type CashInsightsSuspenseQueryHookResult = ReturnType<typeof useCashInsightsSuspenseQuery>;
export type CashInsightsQueryResult = Apollo.QueryResult<GraphqlTypes.CashInsightsQuery, GraphqlTypes.CashInsightsQueryVariables>;
export const GetDistributionBatchesForCanopyPaymentBatchCreationDocument = gql`
    query GetDistributionBatchesForCanopyPaymentBatchCreation($filters: DistributionBatchesFilters, $first: Int, $after: String, $last: Int, $before: String, $sort: [DistributionBatchObjectTypeSortEnum]) {
  distributionBatches(
    filters: $filters
    first: $first
    after: $after
    last: $last
    before: $before
    sort: $sort
  ) {
    count
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        description
        effectiveDate
        distributionCount
        batchTotalDetails {
          amountPayable {
            monies
          }
        }
        amountPaidViaAutomatedPayments
        paymentBatches(filter: {batchStatus: [READY_FOR_TREASURY_REVIEW]}) {
          id
          status
        }
        amountPaid {
          ach {
            monies
          }
          check {
            monies
          }
          manual {
            monies
          }
        }
        arena {
          id
          name
          jsqHostname
        }
        entity {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistributionBatchesForCanopyPaymentBatchCreationQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchesForCanopyPaymentBatchCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchesForCanopyPaymentBatchCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchesForCanopyPaymentBatchCreationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetDistributionBatchesForCanopyPaymentBatchCreationQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchesForCanopyPaymentBatchCreationDocument, options);
      }
export function useGetDistributionBatchesForCanopyPaymentBatchCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchesForCanopyPaymentBatchCreationDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchesForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>;
export function useGetDistributionBatchesForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery | undefined, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>;
export function useGetDistributionBatchesForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchesForCanopyPaymentBatchCreationDocument, options);
        }
export type GetDistributionBatchesForCanopyPaymentBatchCreationQueryHookResult = ReturnType<typeof useGetDistributionBatchesForCanopyPaymentBatchCreationQuery>;
export type GetDistributionBatchesForCanopyPaymentBatchCreationLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchesForCanopyPaymentBatchCreationLazyQuery>;
export type GetDistributionBatchesForCanopyPaymentBatchCreationSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchesForCanopyPaymentBatchCreationSuspenseQuery>;
export type GetDistributionBatchesForCanopyPaymentBatchCreationQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchesForCanopyPaymentBatchCreationQueryVariables>;
export const GetPaymentBatchesForDistributionDocument = gql`
    query GetPaymentBatchesForDistribution($inputFilter: PaymentBatchesFilterInput!) {
  paymentBatchesConnection(
    inputFilter: $inputFilter
    paginationArgs: {first: 100, paginationType: OFFSET}
  ) {
    edges {
      node {
        id
        createdAt
        objectsCount
        netAmount
        status
        fundingPayment {
          id
          method
        }
        payments {
          objectId
          status
          method
          amount
          scheduledProcessDate
        }
        creatorId
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetPaymentBatchesForDistributionQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesForDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesForDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesForDistributionQuery({
 *   variables: {
 *      inputFilter: // value for 'inputFilter'
 *   },
 * });
 */
export function useGetPaymentBatchesForDistributionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>(GetPaymentBatchesForDistributionDocument, options);
      }
export function useGetPaymentBatchesForDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>(GetPaymentBatchesForDistributionDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesForDistributionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>;
export function useGetPaymentBatchesForDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesForDistributionQuery | undefined, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>;
export function useGetPaymentBatchesForDistributionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>(GetPaymentBatchesForDistributionDocument, options);
        }
export type GetPaymentBatchesForDistributionQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionQuery>;
export type GetPaymentBatchesForDistributionLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionLazyQuery>;
export type GetPaymentBatchesForDistributionSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesForDistributionSuspenseQuery>;
export type GetPaymentBatchesForDistributionQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesForDistributionQuery, GraphqlTypes.GetPaymentBatchesForDistributionQueryVariables>;
export const GetDistributionBatchForSlideoutDocument = gql`
    query GetDistributionBatchForSlideout($distributionBatchId: ID!) {
  distributionBatch(id: $distributionBatchId) {
    id
    description
    effectiveDate
    distributionCount
    batchTotalDetails {
      amountPayable {
        monies
      }
    }
    amountPaidViaAutomatedPayments
    amountPaid {
      ach {
        monies
      }
      check {
        monies
      }
      manual {
        monies
      }
    }
    arena {
      id
      name
      jsqHostname
    }
    entity {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDistributionBatchForSlideoutQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchForSlideoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchForSlideoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchForSlideoutQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *   },
 * });
 */
export function useGetDistributionBatchForSlideoutQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>(GetDistributionBatchForSlideoutDocument, options);
      }
export function useGetDistributionBatchForSlideoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>(GetDistributionBatchForSlideoutDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchForSlideoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>;
export function useGetDistributionBatchForSlideoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForSlideoutQuery | undefined, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>;
export function useGetDistributionBatchForSlideoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>(GetDistributionBatchForSlideoutDocument, options);
        }
export type GetDistributionBatchForSlideoutQueryHookResult = ReturnType<typeof useGetDistributionBatchForSlideoutQuery>;
export type GetDistributionBatchForSlideoutLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchForSlideoutLazyQuery>;
export type GetDistributionBatchForSlideoutSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchForSlideoutSuspenseQuery>;
export type GetDistributionBatchForSlideoutQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchForSlideoutQuery, GraphqlTypes.GetDistributionBatchForSlideoutQueryVariables>;
export const CreateCanopyPaymentBatchDocument = gql`
    mutation CreateCanopyPaymentBatch($createPaymentBatchInput: CreatePaymentBatchInput!) {
  createPaymentBatch(createPaymentBatchInput: $createPaymentBatchInput) {
    id
  }
}
    `;
export type CreateCanopyPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateCanopyPaymentBatchMutation, GraphqlTypes.CreateCanopyPaymentBatchMutationVariables>;

/**
 * __useCreateCanopyPaymentBatchMutation__
 *
 * To run a mutation, you first call `useCreateCanopyPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCanopyPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCanopyPaymentBatchMutation, { data, loading, error }] = useCreateCanopyPaymentBatchMutation({
 *   variables: {
 *      createPaymentBatchInput: // value for 'createPaymentBatchInput'
 *   },
 * });
 */
export function useCreateCanopyPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateCanopyPaymentBatchMutation, GraphqlTypes.CreateCanopyPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateCanopyPaymentBatchMutation, GraphqlTypes.CreateCanopyPaymentBatchMutationVariables>(CreateCanopyPaymentBatchDocument, options);
      }
export type CreateCanopyPaymentBatchMutationHookResult = ReturnType<typeof useCreateCanopyPaymentBatchMutation>;
export type CreateCanopyPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreateCanopyPaymentBatchMutation>;
export type CreateCanopyPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateCanopyPaymentBatchMutation, GraphqlTypes.CreateCanopyPaymentBatchMutationVariables>;
export const GetDistributionBatchForCanopyPaymentBatchCreationDocument = gql`
    query GetDistributionBatchForCanopyPaymentBatchCreation($distributionBatchId: ID!, $picrCasesEnabled: Boolean!) {
  distributionBatch(id: $distributionBatchId) {
    id
    arena {
      id
      name
    }
    entity {
      id
      name
      currency {
        id
        code
      }
      bankAccount {
        id
        verificationStatus
        paymentCapabilities {
          wirePayments
          achPayments
        }
      }
    }
    instances {
      id
      amountDistributed {
        monies
      }
      netAmountAdjustments {
        monies
      }
      amountPayable {
        monies
      }
      hasAutomatedPayment
      hasPayment
      position {
        id
        account {
          id
          gpTitle
        }
        hasPendingPaymentPrefChangeRequests
        hasPassedPicrComplianceChecks @include(if: $picrCasesEnabled)
        paymentPrefUpdatedAt
        paymentPref {
          id
          paymentMethod
          bankInfoRedacted
          verificationStatus
          watchlistStatus {
            id
            status
          }
          paymentPrefFull {
            ... on WirePaymentPrefObjectType {
              paymentPrefId
              referenceToBeneficiary
              wireBbi {
                field0
                field1
                field2
                field3
              }
            }
            ... on AchPaymentPrefObjectType {
              paymentPrefId
            }
            ... on CheckPaymentPrefObjectType {
              paymentPrefId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDistributionBatchForCanopyPaymentBatchCreationQuery__
 *
 * To run a query within a React component, call `useGetDistributionBatchForCanopyPaymentBatchCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBatchForCanopyPaymentBatchCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBatchForCanopyPaymentBatchCreationQuery({
 *   variables: {
 *      distributionBatchId: // value for 'distributionBatchId'
 *      picrCasesEnabled: // value for 'picrCasesEnabled'
 *   },
 * });
 */
export function useGetDistributionBatchForCanopyPaymentBatchCreationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables> & ({ variables: GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchForCanopyPaymentBatchCreationDocument, options);
      }
export function useGetDistributionBatchForCanopyPaymentBatchCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchForCanopyPaymentBatchCreationDocument, options);
        }
// @ts-ignore
export function useGetDistributionBatchForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>;
export function useGetDistributionBatchForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery | undefined, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>;
export function useGetDistributionBatchForCanopyPaymentBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>(GetDistributionBatchForCanopyPaymentBatchCreationDocument, options);
        }
export type GetDistributionBatchForCanopyPaymentBatchCreationQueryHookResult = ReturnType<typeof useGetDistributionBatchForCanopyPaymentBatchCreationQuery>;
export type GetDistributionBatchForCanopyPaymentBatchCreationLazyQueryHookResult = ReturnType<typeof useGetDistributionBatchForCanopyPaymentBatchCreationLazyQuery>;
export type GetDistributionBatchForCanopyPaymentBatchCreationSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBatchForCanopyPaymentBatchCreationSuspenseQuery>;
export type GetDistributionBatchForCanopyPaymentBatchCreationQueryResult = Apollo.QueryResult<GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQuery, GraphqlTypes.GetDistributionBatchForCanopyPaymentBatchCreationQueryVariables>;
export const GetEntityByArenaFilteredDocument = gql`
    query GetEntityByArenaFiltered($filters: EntitiesFilters) {
  investmentEntities(filters: $filters) {
    edges {
      node {
        ...EntityBankAccountFragment
      }
    }
  }
}
    ${EntityBankAccountFragmentFragmentDoc}`;

/**
 * __useGetEntityByArenaFilteredQuery__
 *
 * To run a query within a React component, call `useGetEntityByArenaFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityByArenaFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityByArenaFilteredQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetEntityByArenaFilteredQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>(GetEntityByArenaFilteredDocument, options);
      }
export function useGetEntityByArenaFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>(GetEntityByArenaFilteredDocument, options);
        }
// @ts-ignore
export function useGetEntityByArenaFilteredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>;
export function useGetEntityByArenaFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityByArenaFilteredQuery | undefined, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>;
export function useGetEntityByArenaFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>(GetEntityByArenaFilteredDocument, options);
        }
export type GetEntityByArenaFilteredQueryHookResult = ReturnType<typeof useGetEntityByArenaFilteredQuery>;
export type GetEntityByArenaFilteredLazyQueryHookResult = ReturnType<typeof useGetEntityByArenaFilteredLazyQuery>;
export type GetEntityByArenaFilteredSuspenseQueryHookResult = ReturnType<typeof useGetEntityByArenaFilteredSuspenseQuery>;
export type GetEntityByArenaFilteredQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityByArenaFilteredQuery, GraphqlTypes.GetEntityByArenaFilteredQueryVariables>;
export const GetFundsListDocument = gql`
    query GetFundsList($first: Int = 50, $after: String, $sort: [AccountObjectTypeSortEnum] = [NAME_ASC]) {
  investmentEntitiesByArena(
    first: $first
    after: $after
    sort: $sort
    filterEntitiesWithTransactions: false
  ) {
    edges {
      node {
        id
        name
        arena {
          id
          name
          domain
        }
        transactionBankAccounts {
          id
          bankName
          bankInfoRedacted
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    count
  }
}
    `;

/**
 * __useGetFundsListQuery__
 *
 * To run a query within a React component, call `useGetFundsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFundsListQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>(GetFundsListDocument, options);
      }
export function useGetFundsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>(GetFundsListDocument, options);
        }
// @ts-ignore
export function useGetFundsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>;
export function useGetFundsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundsListQuery | undefined, GraphqlTypes.GetFundsListQueryVariables>;
export function useGetFundsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>(GetFundsListDocument, options);
        }
export type GetFundsListQueryHookResult = ReturnType<typeof useGetFundsListQuery>;
export type GetFundsListLazyQueryHookResult = ReturnType<typeof useGetFundsListLazyQuery>;
export type GetFundsListSuspenseQueryHookResult = ReturnType<typeof useGetFundsListSuspenseQuery>;
export type GetFundsListQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundsListQuery, GraphqlTypes.GetFundsListQueryVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts($accountFilters: AccountFilterInput!) {
  accounts(accountFilters: $accountFilters) {
    edges {
      node {
        id
        name
      }
      cursor
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      accountFilters: // value for 'accountFilters'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables> & ({ variables: GraphqlTypes.GetAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountsQuery | undefined, GraphqlTypes.GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountsQuery, GraphqlTypes.GetAccountsQueryVariables>;
export const GetPositionsByAccountDocument = gql`
    query GetPositionsByAccount($positionFilters: PositionFilterInput!, $after: String) {
  positions(positionFilters: $positionFilters, after: $after) {
    edges {
      node {
        id
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetPositionsByAccountQuery__
 *
 * To run a query within a React component, call `useGetPositionsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsByAccountQuery({
 *   variables: {
 *      positionFilters: // value for 'positionFilters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPositionsByAccountQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables> & ({ variables: GraphqlTypes.GetPositionsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>(GetPositionsByAccountDocument, options);
      }
export function useGetPositionsByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>(GetPositionsByAccountDocument, options);
        }
// @ts-ignore
export function useGetPositionsByAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>;
export function useGetPositionsByAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsByAccountQuery | undefined, GraphqlTypes.GetPositionsByAccountQueryVariables>;
export function useGetPositionsByAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>(GetPositionsByAccountDocument, options);
        }
export type GetPositionsByAccountQueryHookResult = ReturnType<typeof useGetPositionsByAccountQuery>;
export type GetPositionsByAccountLazyQueryHookResult = ReturnType<typeof useGetPositionsByAccountLazyQuery>;
export type GetPositionsByAccountSuspenseQueryHookResult = ReturnType<typeof useGetPositionsByAccountSuspenseQuery>;
export type GetPositionsByAccountQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsByAccountQuery, GraphqlTypes.GetPositionsByAccountQueryVariables>;
export const GetArenasDocument = gql`
    query GetArenas($searchTerm: String) {
  arenas(searchTerm: $searchTerm) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetArenasQuery__
 *
 * To run a query within a React component, call `useGetArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenasQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
      }
export function useGetArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
// @ts-ignore
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenasQuery | undefined, GraphqlTypes.GetArenasQueryVariables>;
export function useGetArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>(GetArenasDocument, options);
        }
export type GetArenasQueryHookResult = ReturnType<typeof useGetArenasQuery>;
export type GetArenasLazyQueryHookResult = ReturnType<typeof useGetArenasLazyQuery>;
export type GetArenasSuspenseQueryHookResult = ReturnType<typeof useGetArenasSuspenseQuery>;
export type GetArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenasQuery, GraphqlTypes.GetArenasQueryVariables>;
export const GetEntityByArenaDocument = gql`
    query GetEntityByArena($arenaIds: [ID!], $searchTerm: String) {
  investmentEntities(filters: {arenaIds: $arenaIds, nameSearchTerm: $searchTerm}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEntityByArenaQuery__
 *
 * To run a query within a React component, call `useGetEntityByArenaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityByArenaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityByArenaQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetEntityByArenaQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>(GetEntityByArenaDocument, options);
      }
export function useGetEntityByArenaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>(GetEntityByArenaDocument, options);
        }
// @ts-ignore
export function useGetEntityByArenaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>;
export function useGetEntityByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityByArenaQuery | undefined, GraphqlTypes.GetEntityByArenaQueryVariables>;
export function useGetEntityByArenaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>(GetEntityByArenaDocument, options);
        }
export type GetEntityByArenaQueryHookResult = ReturnType<typeof useGetEntityByArenaQuery>;
export type GetEntityByArenaLazyQueryHookResult = ReturnType<typeof useGetEntityByArenaLazyQuery>;
export type GetEntityByArenaSuspenseQueryHookResult = ReturnType<typeof useGetEntityByArenaSuspenseQuery>;
export type GetEntityByArenaQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityByArenaQuery, GraphqlTypes.GetEntityByArenaQueryVariables>;
export const CreatePayablePaymentBatchDocument = gql`
    mutation CreatePayablePaymentBatch($createPayablePaymentBatchInput: CreatePayablePaymentBatchInput!) {
  createPayablePaymentBatch(
    createPayablePaymentBatchInput: $createPayablePaymentBatchInput
  ) {
    id
  }
}
    `;
export type CreatePayablePaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayablePaymentBatchMutation, GraphqlTypes.CreatePayablePaymentBatchMutationVariables>;

/**
 * __useCreatePayablePaymentBatchMutation__
 *
 * To run a mutation, you first call `useCreatePayablePaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayablePaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayablePaymentBatchMutation, { data, loading, error }] = useCreatePayablePaymentBatchMutation({
 *   variables: {
 *      createPayablePaymentBatchInput: // value for 'createPayablePaymentBatchInput'
 *   },
 * });
 */
export function useCreatePayablePaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayablePaymentBatchMutation, GraphqlTypes.CreatePayablePaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayablePaymentBatchMutation, GraphqlTypes.CreatePayablePaymentBatchMutationVariables>(CreatePayablePaymentBatchDocument, options);
      }
export type CreatePayablePaymentBatchMutationHookResult = ReturnType<typeof useCreatePayablePaymentBatchMutation>;
export type CreatePayablePaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayablePaymentBatchMutation>;
export type CreatePayablePaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayablePaymentBatchMutation, GraphqlTypes.CreatePayablePaymentBatchMutationVariables>;
export const GetPayableFromIdDocument = gql`
    query GetPayableFromId($payableId: ID!) {
  payable(payableId: $payableId) {
    id
    payee {
      id
      name
      payeeType
    }
    amount
    description
    supportingDocuments {
      id
      name
      viewUrl
    }
    entity {
      id
      name
      bankAccount {
        id
        bankName
        bankInfoRedacted
        ownerName
      }
    }
    arena {
      id
    }
  }
}
    `;

/**
 * __useGetPayableFromIdQuery__
 *
 * To run a query within a React component, call `useGetPayableFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayableFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayableFromIdQuery({
 *   variables: {
 *      payableId: // value for 'payableId'
 *   },
 * });
 */
export function useGetPayableFromIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables> & ({ variables: GraphqlTypes.GetPayableFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>(GetPayableFromIdDocument, options);
      }
export function useGetPayableFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>(GetPayableFromIdDocument, options);
        }
// @ts-ignore
export function useGetPayableFromIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>;
export function useGetPayableFromIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayableFromIdQuery | undefined, GraphqlTypes.GetPayableFromIdQueryVariables>;
export function useGetPayableFromIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>(GetPayableFromIdDocument, options);
        }
export type GetPayableFromIdQueryHookResult = ReturnType<typeof useGetPayableFromIdQuery>;
export type GetPayableFromIdLazyQueryHookResult = ReturnType<typeof useGetPayableFromIdLazyQuery>;
export type GetPayableFromIdSuspenseQueryHookResult = ReturnType<typeof useGetPayableFromIdSuspenseQuery>;
export type GetPayableFromIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayableFromIdQuery, GraphqlTypes.GetPayableFromIdQueryVariables>;
export const GetPayablesDocument = gql`
    query GetPayables($first: Int, $after: String, $last: Int, $before: String, $filters: PayableFilterInput, $sortBy: PayablesSortField, $sortDirection: SortDirection) {
  payables(
    first: $first
    after: $after
    last: $last
    before: $before
    filters: $filters
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    count
    edges {
      node {
        id
        description
        invoiceNumber
        invoiceDate
        dueDate
        createdAt
        modifiedAt
        amount
        payee {
          id
          name
        }
        entity {
          id
          name
        }
        arena {
          id
          name
        }
        supportingDocuments {
          id
          viewUrl
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPayablesQuery__
 *
 * To run a query within a React component, call `useGetPayablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayablesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetPayablesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>(GetPayablesDocument, options);
      }
export function useGetPayablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>(GetPayablesDocument, options);
        }
// @ts-ignore
export function useGetPayablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>;
export function useGetPayablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayablesQuery | undefined, GraphqlTypes.GetPayablesQueryVariables>;
export function useGetPayablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>(GetPayablesDocument, options);
        }
export type GetPayablesQueryHookResult = ReturnType<typeof useGetPayablesQuery>;
export type GetPayablesLazyQueryHookResult = ReturnType<typeof useGetPayablesLazyQuery>;
export type GetPayablesSuspenseQueryHookResult = ReturnType<typeof useGetPayablesSuspenseQuery>;
export type GetPayablesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayablesQuery, GraphqlTypes.GetPayablesQueryVariables>;
export const GetPayeeForBankAccountDetailsDocument = gql`
    query GetPayeeForBankAccountDetails($payeeId: ID!) {
  payee(payeeId: $payeeId) {
    id
    name
    status
    address {
      street
      street2
      street3
      city
      state {
        name
      }
      country {
        name
      }
      region
      postalCode
    }
    paymentPref {
      ...DetailedPaymentPref
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;

/**
 * __useGetPayeeForBankAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetPayeeForBankAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayeeForBankAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayeeForBankAccountDetailsQuery({
 *   variables: {
 *      payeeId: // value for 'payeeId'
 *   },
 * });
 */
export function useGetPayeeForBankAccountDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables> & ({ variables: GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>(GetPayeeForBankAccountDetailsDocument, options);
      }
export function useGetPayeeForBankAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>(GetPayeeForBankAccountDetailsDocument, options);
        }
// @ts-ignore
export function useGetPayeeForBankAccountDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>;
export function useGetPayeeForBankAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeForBankAccountDetailsQuery | undefined, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>;
export function useGetPayeeForBankAccountDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>(GetPayeeForBankAccountDetailsDocument, options);
        }
export type GetPayeeForBankAccountDetailsQueryHookResult = ReturnType<typeof useGetPayeeForBankAccountDetailsQuery>;
export type GetPayeeForBankAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetPayeeForBankAccountDetailsLazyQuery>;
export type GetPayeeForBankAccountDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPayeeForBankAccountDetailsSuspenseQuery>;
export type GetPayeeForBankAccountDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayeeForBankAccountDetailsQuery, GraphqlTypes.GetPayeeForBankAccountDetailsQueryVariables>;
export const GetPayeesForPayeeFilterDocument = gql`
    query GetPayeesForPayeeFilter($filters: PayeeFilterInput, $first: Int, $after: String, $last: Int, $before: String) {
  payees(
    filters: $filters
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    count
    edges {
      node {
        id
        name
        payeeType
        status
        paymentPref {
          id
          bankInfoRedacted
          watchlistStatus {
            id
            status
            name
            investorDiligenceType
            arenaId
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPayeesForPayeeFilterQuery__
 *
 * To run a query within a React component, call `useGetPayeesForPayeeFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayeesForPayeeFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayeesForPayeeFilterQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetPayeesForPayeeFilterQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>(GetPayeesForPayeeFilterDocument, options);
      }
export function useGetPayeesForPayeeFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>(GetPayeesForPayeeFilterDocument, options);
        }
// @ts-ignore
export function useGetPayeesForPayeeFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>;
export function useGetPayeesForPayeeFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeesForPayeeFilterQuery | undefined, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>;
export function useGetPayeesForPayeeFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>(GetPayeesForPayeeFilterDocument, options);
        }
export type GetPayeesForPayeeFilterQueryHookResult = ReturnType<typeof useGetPayeesForPayeeFilterQuery>;
export type GetPayeesForPayeeFilterLazyQueryHookResult = ReturnType<typeof useGetPayeesForPayeeFilterLazyQuery>;
export type GetPayeesForPayeeFilterSuspenseQueryHookResult = ReturnType<typeof useGetPayeesForPayeeFilterSuspenseQuery>;
export type GetPayeesForPayeeFilterQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayeesForPayeeFilterQuery, GraphqlTypes.GetPayeesForPayeeFilterQueryVariables>;
export const CreatePayableDocument = gql`
    mutation CreatePayable($input: CreatePayableInput!) {
  createPayable(input: $input) {
    ... on CreatePayableResponse {
      payable {
        id
        amount
        description
        dueDate
        invoiceNumber
        invoiceDate
        payee {
          id
          name
          payeeType
        }
        entity {
          id
          name
        }
        supportingDocuments {
          id
          name
          size
          contentType
          s3ObjectKey
          documentType
        }
        createdAt
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type CreatePayableMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayableMutation, GraphqlTypes.CreatePayableMutationVariables>;

/**
 * __useCreatePayableMutation__
 *
 * To run a mutation, you first call `useCreatePayableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayableMutation, { data, loading, error }] = useCreatePayableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayableMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayableMutation, GraphqlTypes.CreatePayableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayableMutation, GraphqlTypes.CreatePayableMutationVariables>(CreatePayableDocument, options);
      }
export type CreatePayableMutationHookResult = ReturnType<typeof useCreatePayableMutation>;
export type CreatePayableMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayableMutation>;
export type CreatePayableMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayableMutation, GraphqlTypes.CreatePayableMutationVariables>;
export const GetTreasuryArenasDocument = gql`
    query GetTreasuryArenas($searchTerm: String) {
  treasuryArenas(searchTerm: $searchTerm) {
    edges {
      node {
        id
        name
        domain
      }
    }
  }
}
    `;

/**
 * __useGetTreasuryArenasQuery__
 *
 * To run a query within a React component, call `useGetTreasuryArenasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreasuryArenasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreasuryArenasQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetTreasuryArenasQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>(GetTreasuryArenasDocument, options);
      }
export function useGetTreasuryArenasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>(GetTreasuryArenasDocument, options);
        }
// @ts-ignore
export function useGetTreasuryArenasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>;
export function useGetTreasuryArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTreasuryArenasQuery | undefined, GraphqlTypes.GetTreasuryArenasQueryVariables>;
export function useGetTreasuryArenasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>(GetTreasuryArenasDocument, options);
        }
export type GetTreasuryArenasQueryHookResult = ReturnType<typeof useGetTreasuryArenasQuery>;
export type GetTreasuryArenasLazyQueryHookResult = ReturnType<typeof useGetTreasuryArenasLazyQuery>;
export type GetTreasuryArenasSuspenseQueryHookResult = ReturnType<typeof useGetTreasuryArenasSuspenseQuery>;
export type GetTreasuryArenasQueryResult = Apollo.QueryResult<GraphqlTypes.GetTreasuryArenasQuery, GraphqlTypes.GetTreasuryArenasQueryVariables>;
export const GetPayeeLogsDocument = gql`
    query GetPayeeLogs($payeeId: ID!) {
  payee(payeeId: $payeeId) {
    id
    logs {
      ...DetailedPayeeLog
    }
  }
}
    ${DetailedPayeeLogFragmentDoc}`;

/**
 * __useGetPayeeLogsQuery__
 *
 * To run a query within a React component, call `useGetPayeeLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayeeLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayeeLogsQuery({
 *   variables: {
 *      payeeId: // value for 'payeeId'
 *   },
 * });
 */
export function useGetPayeeLogsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables> & ({ variables: GraphqlTypes.GetPayeeLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>(GetPayeeLogsDocument, options);
      }
export function useGetPayeeLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>(GetPayeeLogsDocument, options);
        }
// @ts-ignore
export function useGetPayeeLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>;
export function useGetPayeeLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeLogsQuery | undefined, GraphqlTypes.GetPayeeLogsQueryVariables>;
export function useGetPayeeLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>(GetPayeeLogsDocument, options);
        }
export type GetPayeeLogsQueryHookResult = ReturnType<typeof useGetPayeeLogsQuery>;
export type GetPayeeLogsLazyQueryHookResult = ReturnType<typeof useGetPayeeLogsLazyQuery>;
export type GetPayeeLogsSuspenseQueryHookResult = ReturnType<typeof useGetPayeeLogsSuspenseQuery>;
export type GetPayeeLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayeeLogsQuery, GraphqlTypes.GetPayeeLogsQueryVariables>;
export const GetPayeeDocument = gql`
    query GetPayee($payeeId: ID!) {
  currentUser {
    id
    canRevealPaymentPrefPermission
    isStaffAdminUser
    emailAddress
    firstName
    lastName
    globalActivated
  }
  payee(payeeId: $payeeId) {
    id
    name
    payeeType
    status
    notes
    form1099Required
    taxId
    lastModifiedBy {
      id
      emailAddress
    }
    arena {
      id
      name
    }
    taxIdCountry {
      id
      code
      name
      alpha2code
    }
    address {
      street
      street2
      street3
      city
      state {
        id
        name
        code
      }
      country {
        id
        name
        alpha2code
      }
      region
      postalCode
    }
    paymentPref {
      ...DetailedPaymentPref
    }
    payeeDocuments {
      id
      name
      s3ObjectKey
      documentType
      size
      viewUrl
      contentType
    }
    paymentPrefDocuments {
      id
      name
      s3ObjectKey
      documentType
      size
      viewUrl
      contentType
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;

/**
 * __useGetPayeeQuery__
 *
 * To run a query within a React component, call `useGetPayeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayeeQuery({
 *   variables: {
 *      payeeId: // value for 'payeeId'
 *   },
 * });
 */
export function useGetPayeeQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables> & ({ variables: GraphqlTypes.GetPayeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>(GetPayeeDocument, options);
      }
export function useGetPayeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>(GetPayeeDocument, options);
        }
// @ts-ignore
export function useGetPayeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>;
export function useGetPayeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeeQuery | undefined, GraphqlTypes.GetPayeeQueryVariables>;
export function useGetPayeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>(GetPayeeDocument, options);
        }
export type GetPayeeQueryHookResult = ReturnType<typeof useGetPayeeQuery>;
export type GetPayeeLazyQueryHookResult = ReturnType<typeof useGetPayeeLazyQuery>;
export type GetPayeeSuspenseQueryHookResult = ReturnType<typeof useGetPayeeSuspenseQuery>;
export type GetPayeeQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayeeQuery, GraphqlTypes.GetPayeeQueryVariables>;
export const GetPayeesDocument = gql`
    query GetPayees($filters: PayeeFilterInput, $first: Int, $after: String, $last: Int, $before: String, $sort: [PayeeObjectTypeSortEnum]) {
  payees(
    filters: $filters
    first: $first
    after: $after
    last: $last
    before: $before
    sort: $sort
  ) {
    count
    edges {
      node {
        id
        name
        payeeType
        status
        arena {
          id
          name
        }
        taxIdCountry {
          id
          code
        }
        address {
          street
          state {
            name
          }
          country {
            name
          }
          region
        }
        paymentPref {
          id
          paymentMethod
          bankInfoRedacted
        }
        modifiedAt
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPayeesQuery__
 *
 * To run a query within a React component, call `useGetPayeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayeesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPayeesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>(GetPayeesDocument, options);
      }
export function useGetPayeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>(GetPayeesDocument, options);
        }
// @ts-ignore
export function useGetPayeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>;
export function useGetPayeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPayeesQuery | undefined, GraphqlTypes.GetPayeesQueryVariables>;
export function useGetPayeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>(GetPayeesDocument, options);
        }
export type GetPayeesQueryHookResult = ReturnType<typeof useGetPayeesQuery>;
export type GetPayeesLazyQueryHookResult = ReturnType<typeof useGetPayeesLazyQuery>;
export type GetPayeesSuspenseQueryHookResult = ReturnType<typeof useGetPayeesSuspenseQuery>;
export type GetPayeesQueryResult = Apollo.QueryResult<GraphqlTypes.GetPayeesQuery, GraphqlTypes.GetPayeesQueryVariables>;
export const CreatePayeeInvestmentDocument = gql`
    mutation CreatePayeeInvestment($createPayeeInvestmentInput: CreatePayeeInvestmentInput!) {
  createPayeeInvestment(createPayeeInvestmentInput: $createPayeeInvestmentInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type CreatePayeeInvestmentMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeeInvestmentMutation, GraphqlTypes.CreatePayeeInvestmentMutationVariables>;

/**
 * __useCreatePayeeInvestmentMutation__
 *
 * To run a mutation, you first call `useCreatePayeeInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeeInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeeInvestmentMutation, { data, loading, error }] = useCreatePayeeInvestmentMutation({
 *   variables: {
 *      createPayeeInvestmentInput: // value for 'createPayeeInvestmentInput'
 *   },
 * });
 */
export function useCreatePayeeInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeeInvestmentMutation, GraphqlTypes.CreatePayeeInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeeInvestmentMutation, GraphqlTypes.CreatePayeeInvestmentMutationVariables>(CreatePayeeInvestmentDocument, options);
      }
export type CreatePayeeInvestmentMutationHookResult = ReturnType<typeof useCreatePayeeInvestmentMutation>;
export type CreatePayeeInvestmentMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeeInvestmentMutation>;
export type CreatePayeeInvestmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeeInvestmentMutation, GraphqlTypes.CreatePayeeInvestmentMutationVariables>;
export const CreatePayeeEntityDocument = gql`
    mutation CreatePayeeEntity($createPayeeEntityInput: CreatePayeeEntityInput!) {
  createPayeeEntity(createPayeeEntityInput: $createPayeeEntityInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type CreatePayeeEntityMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeeEntityMutation, GraphqlTypes.CreatePayeeEntityMutationVariables>;

/**
 * __useCreatePayeeEntityMutation__
 *
 * To run a mutation, you first call `useCreatePayeeEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeeEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeeEntityMutation, { data, loading, error }] = useCreatePayeeEntityMutation({
 *   variables: {
 *      createPayeeEntityInput: // value for 'createPayeeEntityInput'
 *   },
 * });
 */
export function useCreatePayeeEntityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeeEntityMutation, GraphqlTypes.CreatePayeeEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeeEntityMutation, GraphqlTypes.CreatePayeeEntityMutationVariables>(CreatePayeeEntityDocument, options);
      }
export type CreatePayeeEntityMutationHookResult = ReturnType<typeof useCreatePayeeEntityMutation>;
export type CreatePayeeEntityMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeeEntityMutation>;
export type CreatePayeeEntityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeeEntityMutation, GraphqlTypes.CreatePayeeEntityMutationVariables>;
export const CreatePayeeVendorDocument = gql`
    mutation CreatePayeeVendor($createPayeeVendorInput: CreatePayeeVendorInput!) {
  createPayeeVendor(createPayeeVendorInput: $createPayeeVendorInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type CreatePayeeVendorMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeeVendorMutation, GraphqlTypes.CreatePayeeVendorMutationVariables>;

/**
 * __useCreatePayeeVendorMutation__
 *
 * To run a mutation, you first call `useCreatePayeeVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeeVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeeVendorMutation, { data, loading, error }] = useCreatePayeeVendorMutation({
 *   variables: {
 *      createPayeeVendorInput: // value for 'createPayeeVendorInput'
 *   },
 * });
 */
export function useCreatePayeeVendorMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeeVendorMutation, GraphqlTypes.CreatePayeeVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeeVendorMutation, GraphqlTypes.CreatePayeeVendorMutationVariables>(CreatePayeeVendorDocument, options);
      }
export type CreatePayeeVendorMutationHookResult = ReturnType<typeof useCreatePayeeVendorMutation>;
export type CreatePayeeVendorMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeeVendorMutation>;
export type CreatePayeeVendorMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeeVendorMutation, GraphqlTypes.CreatePayeeVendorMutationVariables>;
export const ApprovePayeeDocument = gql`
    mutation ApprovePayee($payeeId: ID!) {
  approvePayee(payeeId: $payeeId) {
    id
    name
    payeeType
    status
  }
}
    `;
export type ApprovePayeeMutationFn = Apollo.MutationFunction<GraphqlTypes.ApprovePayeeMutation, GraphqlTypes.ApprovePayeeMutationVariables>;

/**
 * __useApprovePayeeMutation__
 *
 * To run a mutation, you first call `useApprovePayeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePayeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePayeeMutation, { data, loading, error }] = useApprovePayeeMutation({
 *   variables: {
 *      payeeId: // value for 'payeeId'
 *   },
 * });
 */
export function useApprovePayeeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApprovePayeeMutation, GraphqlTypes.ApprovePayeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApprovePayeeMutation, GraphqlTypes.ApprovePayeeMutationVariables>(ApprovePayeeDocument, options);
      }
export type ApprovePayeeMutationHookResult = ReturnType<typeof useApprovePayeeMutation>;
export type ApprovePayeeMutationResult = Apollo.MutationResult<GraphqlTypes.ApprovePayeeMutation>;
export type ApprovePayeeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApprovePayeeMutation, GraphqlTypes.ApprovePayeeMutationVariables>;
export const ReturnPayeeDocument = gql`
    mutation ReturnPayee($payeeId: ID!, $reason: String!) {
  returnPayee(payeeId: $payeeId, reason: $reason) {
    id
    name
    payeeType
    status
  }
}
    `;
export type ReturnPayeeMutationFn = Apollo.MutationFunction<GraphqlTypes.ReturnPayeeMutation, GraphqlTypes.ReturnPayeeMutationVariables>;

/**
 * __useReturnPayeeMutation__
 *
 * To run a mutation, you first call `useReturnPayeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnPayeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnPayeeMutation, { data, loading, error }] = useReturnPayeeMutation({
 *   variables: {
 *      payeeId: // value for 'payeeId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useReturnPayeeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReturnPayeeMutation, GraphqlTypes.ReturnPayeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReturnPayeeMutation, GraphqlTypes.ReturnPayeeMutationVariables>(ReturnPayeeDocument, options);
      }
export type ReturnPayeeMutationHookResult = ReturnType<typeof useReturnPayeeMutation>;
export type ReturnPayeeMutationResult = Apollo.MutationResult<GraphqlTypes.ReturnPayeeMutation>;
export type ReturnPayeeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReturnPayeeMutation, GraphqlTypes.ReturnPayeeMutationVariables>;
export const PatchPayeeInvestmentDocument = gql`
    mutation PatchPayeeInvestment($patchPayeeInvestmentInput: PatchPayeeInvestmentInput!) {
  patchPayeeInvestment(patchPayeeInvestmentInput: $patchPayeeInvestmentInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type PatchPayeeInvestmentMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchPayeeInvestmentMutation, GraphqlTypes.PatchPayeeInvestmentMutationVariables>;

/**
 * __usePatchPayeeInvestmentMutation__
 *
 * To run a mutation, you first call `usePatchPayeeInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchPayeeInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchPayeeInvestmentMutation, { data, loading, error }] = usePatchPayeeInvestmentMutation({
 *   variables: {
 *      patchPayeeInvestmentInput: // value for 'patchPayeeInvestmentInput'
 *   },
 * });
 */
export function usePatchPayeeInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchPayeeInvestmentMutation, GraphqlTypes.PatchPayeeInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchPayeeInvestmentMutation, GraphqlTypes.PatchPayeeInvestmentMutationVariables>(PatchPayeeInvestmentDocument, options);
      }
export type PatchPayeeInvestmentMutationHookResult = ReturnType<typeof usePatchPayeeInvestmentMutation>;
export type PatchPayeeInvestmentMutationResult = Apollo.MutationResult<GraphqlTypes.PatchPayeeInvestmentMutation>;
export type PatchPayeeInvestmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchPayeeInvestmentMutation, GraphqlTypes.PatchPayeeInvestmentMutationVariables>;
export const PatchPayeeEntityDocument = gql`
    mutation PatchPayeeEntity($patchPayeeEntityInput: PatchPayeeEntityInput!) {
  patchPayeeEntity(patchPayeeEntityInput: $patchPayeeEntityInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type PatchPayeeEntityMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchPayeeEntityMutation, GraphqlTypes.PatchPayeeEntityMutationVariables>;

/**
 * __usePatchPayeeEntityMutation__
 *
 * To run a mutation, you first call `usePatchPayeeEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchPayeeEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchPayeeEntityMutation, { data, loading, error }] = usePatchPayeeEntityMutation({
 *   variables: {
 *      patchPayeeEntityInput: // value for 'patchPayeeEntityInput'
 *   },
 * });
 */
export function usePatchPayeeEntityMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchPayeeEntityMutation, GraphqlTypes.PatchPayeeEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchPayeeEntityMutation, GraphqlTypes.PatchPayeeEntityMutationVariables>(PatchPayeeEntityDocument, options);
      }
export type PatchPayeeEntityMutationHookResult = ReturnType<typeof usePatchPayeeEntityMutation>;
export type PatchPayeeEntityMutationResult = Apollo.MutationResult<GraphqlTypes.PatchPayeeEntityMutation>;
export type PatchPayeeEntityMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchPayeeEntityMutation, GraphqlTypes.PatchPayeeEntityMutationVariables>;
export const PatchPayeeVendorDocument = gql`
    mutation PatchPayeeVendor($patchPayeeVendorInput: PatchPayeeVendorInput!) {
  patchPayeeVendor(patchPayeeVendorInput: $patchPayeeVendorInput) {
    ...Payee
  }
}
    ${PayeeFragmentDoc}`;
export type PatchPayeeVendorMutationFn = Apollo.MutationFunction<GraphqlTypes.PatchPayeeVendorMutation, GraphqlTypes.PatchPayeeVendorMutationVariables>;

/**
 * __usePatchPayeeVendorMutation__
 *
 * To run a mutation, you first call `usePatchPayeeVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchPayeeVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchPayeeVendorMutation, { data, loading, error }] = usePatchPayeeVendorMutation({
 *   variables: {
 *      patchPayeeVendorInput: // value for 'patchPayeeVendorInput'
 *   },
 * });
 */
export function usePatchPayeeVendorMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PatchPayeeVendorMutation, GraphqlTypes.PatchPayeeVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PatchPayeeVendorMutation, GraphqlTypes.PatchPayeeVendorMutationVariables>(PatchPayeeVendorDocument, options);
      }
export type PatchPayeeVendorMutationHookResult = ReturnType<typeof usePatchPayeeVendorMutation>;
export type PatchPayeeVendorMutationResult = Apollo.MutationResult<GraphqlTypes.PatchPayeeVendorMutation>;
export type PatchPayeeVendorMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PatchPayeeVendorMutation, GraphqlTypes.PatchPayeeVendorMutationVariables>;
export const CreatePaymentBatchDocument = gql`
    mutation CreatePaymentBatch($createPaymentBatchInput: CreatePaymentBatchInput!) {
  createPaymentBatch(createPaymentBatchInput: $createPaymentBatchInput) {
    id
    status
    payments {
      id
      status
    }
  }
}
    `;
export type CreatePaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>;

/**
 * __useCreatePaymentBatchMutation__
 *
 * To run a mutation, you first call `useCreatePaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentBatchMutation, { data, loading, error }] = useCreatePaymentBatchMutation({
 *   variables: {
 *      createPaymentBatchInput: // value for 'createPaymentBatchInput'
 *   },
 * });
 */
export function useCreatePaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>(CreatePaymentBatchDocument, options);
      }
export type CreatePaymentBatchMutationHookResult = ReturnType<typeof useCreatePaymentBatchMutation>;
export type CreatePaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePaymentBatchMutation>;
export type CreatePaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePaymentBatchMutation, GraphqlTypes.CreatePaymentBatchMutationVariables>;
export const GetAccountingPayableForBatchCreationDocument = gql`
    query GetAccountingPayableForBatchCreation($id: ID!, $picrCasesEnabled: Boolean!) {
  accountingPayable(id: $id) {
    id
    objectType
    label
    subtitleLabel
    description
    date
    requestedPaymentDate
    arena {
      id
      name
      jsqHostname
    }
    entity {
      id
      name
      currency {
        code
      }
      bankAccount {
        id
        paymentCapabilities {
          wirePayments
          achPayments
        }
      }
    }
    totalAmountPayable {
      monies
    }
    amountMarkedPaid {
      monies
    }
    amountPaidViaAutomatedPayments
    isPaymentRequested
    payeeCount
    payees {
      id
      objectType
      isMarkedPaid
      hasAutomatedPayment
      amountPayable {
        monies
      }
      position {
        id
        account {
          id
          gpTitle
        }
        hasPendingPaymentPrefChangeRequests
        hasPassedPicrComplianceChecks @include(if: $picrCasesEnabled)
        paymentPref {
          id
          paymentMethod
          verificationStatus
          bankInfoRedacted
          paymentPrefFull {
            ... on WirePaymentPrefObjectType {
              referenceToBeneficiary
              wireBbi {
                field0
                field1
                field2
                field3
              }
            }
          }
          watchlistStatus {
            id
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountingPayableForBatchCreationQuery__
 *
 * To run a query within a React component, call `useGetAccountingPayableForBatchCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingPayableForBatchCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingPayableForBatchCreationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      picrCasesEnabled: // value for 'picrCasesEnabled'
 *   },
 * });
 */
export function useGetAccountingPayableForBatchCreationQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables> & ({ variables: GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>(GetAccountingPayableForBatchCreationDocument, options);
      }
export function useGetAccountingPayableForBatchCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>(GetAccountingPayableForBatchCreationDocument, options);
        }
// @ts-ignore
export function useGetAccountingPayableForBatchCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>;
export function useGetAccountingPayableForBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayableForBatchCreationQuery | undefined, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>;
export function useGetAccountingPayableForBatchCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>(GetAccountingPayableForBatchCreationDocument, options);
        }
export type GetAccountingPayableForBatchCreationQueryHookResult = ReturnType<typeof useGetAccountingPayableForBatchCreationQuery>;
export type GetAccountingPayableForBatchCreationLazyQueryHookResult = ReturnType<typeof useGetAccountingPayableForBatchCreationLazyQuery>;
export type GetAccountingPayableForBatchCreationSuspenseQueryHookResult = ReturnType<typeof useGetAccountingPayableForBatchCreationSuspenseQuery>;
export type GetAccountingPayableForBatchCreationQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountingPayableForBatchCreationQuery, GraphqlTypes.GetAccountingPayableForBatchCreationQueryVariables>;
export const UpdateArenaPaymentMethodSettingsDocument = gql`
    mutation UpdateArenaPaymentMethodSettings($input: UpdateArenaPaymentMethodSettingsInput!) {
  updateArenaPaymentMethodSettings(input: $input) {
    __typename
    ... on UpdateArenaPaymentMethodSettingsSuccessResponse {
      arena {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpdateArenaPaymentMethodSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateArenaPaymentMethodSettingsMutation, GraphqlTypes.UpdateArenaPaymentMethodSettingsMutationVariables>;

/**
 * __useUpdateArenaPaymentMethodSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateArenaPaymentMethodSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArenaPaymentMethodSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArenaPaymentMethodSettingsMutation, { data, loading, error }] = useUpdateArenaPaymentMethodSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateArenaPaymentMethodSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateArenaPaymentMethodSettingsMutation, GraphqlTypes.UpdateArenaPaymentMethodSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateArenaPaymentMethodSettingsMutation, GraphqlTypes.UpdateArenaPaymentMethodSettingsMutationVariables>(UpdateArenaPaymentMethodSettingsDocument, options);
      }
export type UpdateArenaPaymentMethodSettingsMutationHookResult = ReturnType<typeof useUpdateArenaPaymentMethodSettingsMutation>;
export type UpdateArenaPaymentMethodSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateArenaPaymentMethodSettingsMutation>;
export type UpdateArenaPaymentMethodSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateArenaPaymentMethodSettingsMutation, GraphqlTypes.UpdateArenaPaymentMethodSettingsMutationVariables>;
export const GetArenaPaymentMethodSettingsDocument = gql`
    query GetArenaPaymentMethodSettings {
  currentArena {
    id
    paymentRailSettings {
      achEnabled
      wireEnabled
      checkEnabled
      eftEnabled
      sepaEnabled
      bacsEnabled
      becsEnabled
      wireExcludeWhereLocalEnabled
      checkCountryRestrictionEnabled
      checkAllowedCountries {
        id
        name
        alpha2code
      }
    }
  }
}
    `;

/**
 * __useGetArenaPaymentMethodSettingsQuery__
 *
 * To run a query within a React component, call `useGetArenaPaymentMethodSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArenaPaymentMethodSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArenaPaymentMethodSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetArenaPaymentMethodSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>(GetArenaPaymentMethodSettingsDocument, options);
      }
export function useGetArenaPaymentMethodSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>(GetArenaPaymentMethodSettingsDocument, options);
        }
// @ts-ignore
export function useGetArenaPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>;
export function useGetArenaPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetArenaPaymentMethodSettingsQuery | undefined, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>;
export function useGetArenaPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>(GetArenaPaymentMethodSettingsDocument, options);
        }
export type GetArenaPaymentMethodSettingsQueryHookResult = ReturnType<typeof useGetArenaPaymentMethodSettingsQuery>;
export type GetArenaPaymentMethodSettingsLazyQueryHookResult = ReturnType<typeof useGetArenaPaymentMethodSettingsLazyQuery>;
export type GetArenaPaymentMethodSettingsSuspenseQueryHookResult = ReturnType<typeof useGetArenaPaymentMethodSettingsSuspenseQuery>;
export type GetArenaPaymentMethodSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetArenaPaymentMethodSettingsQuery, GraphqlTypes.GetArenaPaymentMethodSettingsQueryVariables>;
export const GetAllCountriesDocument = gql`
    query GetAllCountries {
  countries {
    edges {
      node {
        id
        name
        alpha2code
      }
    }
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
// @ts-ignore
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>;
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCountriesQuery | undefined, GraphqlTypes.GetAllCountriesQueryVariables>;
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesSuspenseQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllCountriesQuery, GraphqlTypes.GetAllCountriesQueryVariables>;
export const UpdateEntityPaymentMethodSettingsDocument = gql`
    mutation UpdateEntityPaymentMethodSettings($input: UpdateEntityPaymentMethodSettingsInput!) {
  updateEntityPaymentMethodSettings(input: $input) {
    __typename
    ... on UpdateEntityPaymentMethodSettingsSuccessResponse {
      entity {
        id
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type UpdateEntityPaymentMethodSettingsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateEntityPaymentMethodSettingsMutation, GraphqlTypes.UpdateEntityPaymentMethodSettingsMutationVariables>;

/**
 * __useUpdateEntityPaymentMethodSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPaymentMethodSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPaymentMethodSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPaymentMethodSettingsMutation, { data, loading, error }] = useUpdateEntityPaymentMethodSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityPaymentMethodSettingsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateEntityPaymentMethodSettingsMutation, GraphqlTypes.UpdateEntityPaymentMethodSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateEntityPaymentMethodSettingsMutation, GraphqlTypes.UpdateEntityPaymentMethodSettingsMutationVariables>(UpdateEntityPaymentMethodSettingsDocument, options);
      }
export type UpdateEntityPaymentMethodSettingsMutationHookResult = ReturnType<typeof useUpdateEntityPaymentMethodSettingsMutation>;
export type UpdateEntityPaymentMethodSettingsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateEntityPaymentMethodSettingsMutation>;
export type UpdateEntityPaymentMethodSettingsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateEntityPaymentMethodSettingsMutation, GraphqlTypes.UpdateEntityPaymentMethodSettingsMutationVariables>;
export const GetEntityPaymentMethodSettingsDocument = gql`
    query GetEntityPaymentMethodSettings($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    bankAccount {
      id
      bankName
      bankInfoRedacted
      ownerName
    }
    paymentRailSettings {
      achEnabled
      wireEnabled
      checkEnabled
      eftEnabled
      sepaEnabled
      bacsEnabled
      becsEnabled
      wireExcludeWhereLocalEnabled
      checkCountryRestrictionEnabled
      checkAllowedCountries {
        id
        name
        alpha2code
      }
    }
  }
}
    `;

/**
 * __useGetEntityPaymentMethodSettingsQuery__
 *
 * To run a query within a React component, call `useGetEntityPaymentMethodSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityPaymentMethodSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityPaymentMethodSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetEntityPaymentMethodSettingsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables> & ({ variables: GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>(GetEntityPaymentMethodSettingsDocument, options);
      }
export function useGetEntityPaymentMethodSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>(GetEntityPaymentMethodSettingsDocument, options);
        }
// @ts-ignore
export function useGetEntityPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>;
export function useGetEntityPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetEntityPaymentMethodSettingsQuery | undefined, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>;
export function useGetEntityPaymentMethodSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>(GetEntityPaymentMethodSettingsDocument, options);
        }
export type GetEntityPaymentMethodSettingsQueryHookResult = ReturnType<typeof useGetEntityPaymentMethodSettingsQuery>;
export type GetEntityPaymentMethodSettingsLazyQueryHookResult = ReturnType<typeof useGetEntityPaymentMethodSettingsLazyQuery>;
export type GetEntityPaymentMethodSettingsSuspenseQueryHookResult = ReturnType<typeof useGetEntityPaymentMethodSettingsSuspenseQuery>;
export type GetEntityPaymentMethodSettingsQueryResult = Apollo.QueryResult<GraphqlTypes.GetEntityPaymentMethodSettingsQuery, GraphqlTypes.GetEntityPaymentMethodSettingsQueryVariables>;
export const GetAllCountriesForEntityDocument = gql`
    query GetAllCountriesForEntity {
  countries {
    edges {
      node {
        id
        name
        alpha2code
      }
    }
  }
}
    `;

/**
 * __useGetAllCountriesForEntityQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesForEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesForEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesForEntityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesForEntityQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>(GetAllCountriesForEntityDocument, options);
      }
export function useGetAllCountriesForEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>(GetAllCountriesForEntityDocument, options);
        }
// @ts-ignore
export function useGetAllCountriesForEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>;
export function useGetAllCountriesForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAllCountriesForEntityQuery | undefined, GraphqlTypes.GetAllCountriesForEntityQueryVariables>;
export function useGetAllCountriesForEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>(GetAllCountriesForEntityDocument, options);
        }
export type GetAllCountriesForEntityQueryHookResult = ReturnType<typeof useGetAllCountriesForEntityQuery>;
export type GetAllCountriesForEntityLazyQueryHookResult = ReturnType<typeof useGetAllCountriesForEntityLazyQuery>;
export type GetAllCountriesForEntitySuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesForEntitySuspenseQuery>;
export type GetAllCountriesForEntityQueryResult = Apollo.QueryResult<GraphqlTypes.GetAllCountriesForEntityQuery, GraphqlTypes.GetAllCountriesForEntityQueryVariables>;
export const UpdatePaymentPrefForAccountsDocument = gql`
    mutation UpdatePaymentPrefForAccounts($objectInput: UpdatePaymentPrefForAccountsInput!) {
  updatePaymentPrefForAccounts(objectInput: $objectInput) {
    __typename
    ... on UpdatePaymentPrefForAccountsOutput {
      changedPositions {
        id
        account {
          id
        }
        paymentPref {
          id
        }
      }
    }
  }
}
    `;
export type UpdatePaymentPrefForAccountsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefForAccountsMutation, GraphqlTypes.UpdatePaymentPrefForAccountsMutationVariables>;

/**
 * __useUpdatePaymentPrefForAccountsMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefForAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefForAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefForAccountsMutation, { data, loading, error }] = useUpdatePaymentPrefForAccountsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefForAccountsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefForAccountsMutation, GraphqlTypes.UpdatePaymentPrefForAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefForAccountsMutation, GraphqlTypes.UpdatePaymentPrefForAccountsMutationVariables>(UpdatePaymentPrefForAccountsDocument, options);
      }
export type UpdatePaymentPrefForAccountsMutationHookResult = ReturnType<typeof useUpdatePaymentPrefForAccountsMutation>;
export type UpdatePaymentPrefForAccountsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefForAccountsMutation>;
export type UpdatePaymentPrefForAccountsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefForAccountsMutation, GraphqlTypes.UpdatePaymentPrefForAccountsMutationVariables>;
export const FederatedCloneAchPaymentPrefDocument = gql`
    mutation FederatedCloneAchPaymentPref($input: CloneAchPaymentPrefInput!) {
  cloneAchPaymentPref(cloneAchPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCloneAchPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCloneAchPaymentPrefMutation, GraphqlTypes.FederatedCloneAchPaymentPrefMutationVariables>;

/**
 * __useFederatedCloneAchPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCloneAchPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCloneAchPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCloneAchPaymentPrefMutation, { data, loading, error }] = useFederatedCloneAchPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCloneAchPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCloneAchPaymentPrefMutation, GraphqlTypes.FederatedCloneAchPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCloneAchPaymentPrefMutation, GraphqlTypes.FederatedCloneAchPaymentPrefMutationVariables>(FederatedCloneAchPaymentPrefDocument, options);
      }
export type FederatedCloneAchPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCloneAchPaymentPrefMutation>;
export type FederatedCloneAchPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCloneAchPaymentPrefMutation>;
export type FederatedCloneAchPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCloneAchPaymentPrefMutation, GraphqlTypes.FederatedCloneAchPaymentPrefMutationVariables>;
export const ClonePaymentPrefToArenasDocument = gql`
    mutation ClonePaymentPrefToArenas($clonePaymentPrefInput: ClonePaymentPrefInput!) {
  clonePaymentPref(clonePaymentPrefInput: $clonePaymentPrefInput) {
    paymentPrefs {
      id
      arenaId
    }
  }
}
    `;
export type ClonePaymentPrefToArenasMutationFn = Apollo.MutationFunction<GraphqlTypes.ClonePaymentPrefToArenasMutation, GraphqlTypes.ClonePaymentPrefToArenasMutationVariables>;

/**
 * __useClonePaymentPrefToArenasMutation__
 *
 * To run a mutation, you first call `useClonePaymentPrefToArenasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePaymentPrefToArenasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePaymentPrefToArenasMutation, { data, loading, error }] = useClonePaymentPrefToArenasMutation({
 *   variables: {
 *      clonePaymentPrefInput: // value for 'clonePaymentPrefInput'
 *   },
 * });
 */
export function useClonePaymentPrefToArenasMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ClonePaymentPrefToArenasMutation, GraphqlTypes.ClonePaymentPrefToArenasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ClonePaymentPrefToArenasMutation, GraphqlTypes.ClonePaymentPrefToArenasMutationVariables>(ClonePaymentPrefToArenasDocument, options);
      }
export type ClonePaymentPrefToArenasMutationHookResult = ReturnType<typeof useClonePaymentPrefToArenasMutation>;
export type ClonePaymentPrefToArenasMutationResult = Apollo.MutationResult<GraphqlTypes.ClonePaymentPrefToArenasMutation>;
export type ClonePaymentPrefToArenasMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ClonePaymentPrefToArenasMutation, GraphqlTypes.ClonePaymentPrefToArenasMutationVariables>;
export const SubmitChangeRequestPaymentPrefLpDocument = gql`
    mutation submitChangeRequestPaymentPrefLp($payloads: [ChangeRequestPayload!]!, $metadata: JSON) {
  submitChangeRequest(
    objectInput: {requestType: UPDATE_POSITION_PAYMENT_PREF_LP, requestPayloads: $payloads, metadata: $metadata}
  ) {
    ... on SubmitChangeRequestResponse {
      responses {
        requestId
        requestType
        requestPayload
        actions
        status
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SubmitChangeRequestPaymentPrefLpMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutationVariables>;

/**
 * __useSubmitChangeRequestPaymentPrefLpMutation__
 *
 * To run a mutation, you first call `useSubmitChangeRequestPaymentPrefLpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChangeRequestPaymentPrefLpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChangeRequestPaymentPrefLpMutation, { data, loading, error }] = useSubmitChangeRequestPaymentPrefLpMutation({
 *   variables: {
 *      payloads: // value for 'payloads'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useSubmitChangeRequestPaymentPrefLpMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutationVariables>(SubmitChangeRequestPaymentPrefLpDocument, options);
      }
export type SubmitChangeRequestPaymentPrefLpMutationHookResult = ReturnType<typeof useSubmitChangeRequestPaymentPrefLpMutation>;
export type SubmitChangeRequestPaymentPrefLpMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutation>;
export type SubmitChangeRequestPaymentPrefLpMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefLpMutationVariables>;
export const ValidateRoutingNumberDocument = gql`
    query ValidateRoutingNumber($validateRoutingNumberInput: ValidateRoutingNumberInput!) {
  validateRoutingNumber(validateRoutingNumberInput: $validateRoutingNumberInput) {
    routingNumber
    routingNumberType
    isValid
    bankName
    bankAddress {
      country
      line1
      line2
      locality
      postalCode
      region
    }
  }
}
    `;

/**
 * __useValidateRoutingNumberQuery__
 *
 * To run a query within a React component, call `useValidateRoutingNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateRoutingNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateRoutingNumberQuery({
 *   variables: {
 *      validateRoutingNumberInput: // value for 'validateRoutingNumberInput'
 *   },
 * });
 */
export function useValidateRoutingNumberQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables> & ({ variables: GraphqlTypes.ValidateRoutingNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>(ValidateRoutingNumberDocument, options);
      }
export function useValidateRoutingNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>(ValidateRoutingNumberDocument, options);
        }
// @ts-ignore
export function useValidateRoutingNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>;
export function useValidateRoutingNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ValidateRoutingNumberQuery | undefined, GraphqlTypes.ValidateRoutingNumberQueryVariables>;
export function useValidateRoutingNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>(ValidateRoutingNumberDocument, options);
        }
export type ValidateRoutingNumberQueryHookResult = ReturnType<typeof useValidateRoutingNumberQuery>;
export type ValidateRoutingNumberLazyQueryHookResult = ReturnType<typeof useValidateRoutingNumberLazyQuery>;
export type ValidateRoutingNumberSuspenseQueryHookResult = ReturnType<typeof useValidateRoutingNumberSuspenseQuery>;
export type ValidateRoutingNumberQueryResult = Apollo.QueryResult<GraphqlTypes.ValidateRoutingNumberQuery, GraphqlTypes.ValidateRoutingNumberQueryVariables>;
export const GetAccountMailingAddressCountryDocument = gql`
    query GetAccountMailingAddressCountry($accountId: ID!) {
  account(accountId: $accountId) {
    id
    mailingAddress {
      country {
        objectName
        objectId
      }
    }
  }
}
    `;

/**
 * __useGetAccountMailingAddressCountryQuery__
 *
 * To run a query within a React component, call `useGetAccountMailingAddressCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountMailingAddressCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountMailingAddressCountryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountMailingAddressCountryQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables> & ({ variables: GraphqlTypes.GetAccountMailingAddressCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>(GetAccountMailingAddressCountryDocument, options);
      }
export function useGetAccountMailingAddressCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>(GetAccountMailingAddressCountryDocument, options);
        }
// @ts-ignore
export function useGetAccountMailingAddressCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>;
export function useGetAccountMailingAddressCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountMailingAddressCountryQuery | undefined, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>;
export function useGetAccountMailingAddressCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>(GetAccountMailingAddressCountryDocument, options);
        }
export type GetAccountMailingAddressCountryQueryHookResult = ReturnType<typeof useGetAccountMailingAddressCountryQuery>;
export type GetAccountMailingAddressCountryLazyQueryHookResult = ReturnType<typeof useGetAccountMailingAddressCountryLazyQuery>;
export type GetAccountMailingAddressCountrySuspenseQueryHookResult = ReturnType<typeof useGetAccountMailingAddressCountrySuspenseQuery>;
export type GetAccountMailingAddressCountryQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountMailingAddressCountryQuery, GraphqlTypes.GetAccountMailingAddressCountryQueryVariables>;
export const RemovePaymentPrefFromAccountDocument = gql`
    mutation RemovePaymentPrefFromAccount($input: RemovePaymentPrefFromAccountInput!) {
  removePaymentPrefFromAccount(objectInput: $input) {
    ... on RemovePaymentPrefFromAccountResponse {
      updatedPositions {
        id
        paymentPref {
          id
        }
      }
    }
  }
}
    `;
export type RemovePaymentPrefFromAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.RemovePaymentPrefFromAccountMutation, GraphqlTypes.RemovePaymentPrefFromAccountMutationVariables>;

/**
 * __useRemovePaymentPrefFromAccountMutation__
 *
 * To run a mutation, you first call `useRemovePaymentPrefFromAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentPrefFromAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentPrefFromAccountMutation, { data, loading, error }] = useRemovePaymentPrefFromAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePaymentPrefFromAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemovePaymentPrefFromAccountMutation, GraphqlTypes.RemovePaymentPrefFromAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemovePaymentPrefFromAccountMutation, GraphqlTypes.RemovePaymentPrefFromAccountMutationVariables>(RemovePaymentPrefFromAccountDocument, options);
      }
export type RemovePaymentPrefFromAccountMutationHookResult = ReturnType<typeof useRemovePaymentPrefFromAccountMutation>;
export type RemovePaymentPrefFromAccountMutationResult = Apollo.MutationResult<GraphqlTypes.RemovePaymentPrefFromAccountMutation>;
export type RemovePaymentPrefFromAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemovePaymentPrefFromAccountMutation, GraphqlTypes.RemovePaymentPrefFromAccountMutationVariables>;
export const RemovePaymentPrefFromPositionDocument = gql`
    mutation RemovePaymentPrefFromPosition($input: RemovePaymentPrefFromPositionInput!) {
  removePaymentPrefFromPosition(objectInput: $input) {
    ... on RemovePaymentPrefFromPositionOutput {
      position {
        id
        paymentPref {
          id
        }
      }
    }
  }
}
    `;
export type RemovePaymentPrefFromPositionMutationFn = Apollo.MutationFunction<GraphqlTypes.RemovePaymentPrefFromPositionMutation, GraphqlTypes.RemovePaymentPrefFromPositionMutationVariables>;

/**
 * __useRemovePaymentPrefFromPositionMutation__
 *
 * To run a mutation, you first call `useRemovePaymentPrefFromPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentPrefFromPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentPrefFromPositionMutation, { data, loading, error }] = useRemovePaymentPrefFromPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePaymentPrefFromPositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemovePaymentPrefFromPositionMutation, GraphqlTypes.RemovePaymentPrefFromPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemovePaymentPrefFromPositionMutation, GraphqlTypes.RemovePaymentPrefFromPositionMutationVariables>(RemovePaymentPrefFromPositionDocument, options);
      }
export type RemovePaymentPrefFromPositionMutationHookResult = ReturnType<typeof useRemovePaymentPrefFromPositionMutation>;
export type RemovePaymentPrefFromPositionMutationResult = Apollo.MutationResult<GraphqlTypes.RemovePaymentPrefFromPositionMutation>;
export type RemovePaymentPrefFromPositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemovePaymentPrefFromPositionMutation, GraphqlTypes.RemovePaymentPrefFromPositionMutationVariables>;
export const GetNocPaymentDetailsDocument = gql`
    query GetNocPaymentDetails($id: ID!) {
  payment(id: $id) {
    id
    amount
    method
    status
    referenceNumber
    scheduledProcessDate
    position {
      id
      account {
        id
        name
      }
    }
    bankAccount {
      id
      bankInfoRedacted
    }
  }
}
    `;

/**
 * __useGetNocPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetNocPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNocPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNocPaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNocPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables> & ({ variables: GraphqlTypes.GetNocPaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>(GetNocPaymentDetailsDocument, options);
      }
export function useGetNocPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>(GetNocPaymentDetailsDocument, options);
        }
// @ts-ignore
export function useGetNocPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>;
export function useGetNocPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetNocPaymentDetailsQuery | undefined, GraphqlTypes.GetNocPaymentDetailsQueryVariables>;
export function useGetNocPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>(GetNocPaymentDetailsDocument, options);
        }
export type GetNocPaymentDetailsQueryHookResult = ReturnType<typeof useGetNocPaymentDetailsQuery>;
export type GetNocPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetNocPaymentDetailsLazyQuery>;
export type GetNocPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetNocPaymentDetailsSuspenseQuery>;
export type GetNocPaymentDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetNocPaymentDetailsQuery, GraphqlTypes.GetNocPaymentDetailsQueryVariables>;
export const CreatePayeePaymentPrefAchDocument = gql`
    mutation CreatePayeePaymentPrefAch($input: CreateAchPaymentPrefInput!) {
  createAchPaymentPref(createAchPaymentPrefInput: $input) {
    paymentPref {
      ...DetailedPaymentPref
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;
export type CreatePayeePaymentPrefAchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeePaymentPrefAchMutation, GraphqlTypes.CreatePayeePaymentPrefAchMutationVariables>;

/**
 * __useCreatePayeePaymentPrefAchMutation__
 *
 * To run a mutation, you first call `useCreatePayeePaymentPrefAchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeePaymentPrefAchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeePaymentPrefAchMutation, { data, loading, error }] = useCreatePayeePaymentPrefAchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayeePaymentPrefAchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeePaymentPrefAchMutation, GraphqlTypes.CreatePayeePaymentPrefAchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeePaymentPrefAchMutation, GraphqlTypes.CreatePayeePaymentPrefAchMutationVariables>(CreatePayeePaymentPrefAchDocument, options);
      }
export type CreatePayeePaymentPrefAchMutationHookResult = ReturnType<typeof useCreatePayeePaymentPrefAchMutation>;
export type CreatePayeePaymentPrefAchMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeePaymentPrefAchMutation>;
export type CreatePayeePaymentPrefAchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeePaymentPrefAchMutation, GraphqlTypes.CreatePayeePaymentPrefAchMutationVariables>;
export const CreatePayeePaymentPrefWireDocument = gql`
    mutation CreatePayeePaymentPrefWire($input: CreateWirePaymentPrefInput!) {
  createWirePaymentPref(createWirePaymentPrefInput: $input) {
    paymentPref {
      ...DetailedPaymentPref
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;
export type CreatePayeePaymentPrefWireMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeePaymentPrefWireMutation, GraphqlTypes.CreatePayeePaymentPrefWireMutationVariables>;

/**
 * __useCreatePayeePaymentPrefWireMutation__
 *
 * To run a mutation, you first call `useCreatePayeePaymentPrefWireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeePaymentPrefWireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeePaymentPrefWireMutation, { data, loading, error }] = useCreatePayeePaymentPrefWireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayeePaymentPrefWireMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeePaymentPrefWireMutation, GraphqlTypes.CreatePayeePaymentPrefWireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeePaymentPrefWireMutation, GraphqlTypes.CreatePayeePaymentPrefWireMutationVariables>(CreatePayeePaymentPrefWireDocument, options);
      }
export type CreatePayeePaymentPrefWireMutationHookResult = ReturnType<typeof useCreatePayeePaymentPrefWireMutation>;
export type CreatePayeePaymentPrefWireMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeePaymentPrefWireMutation>;
export type CreatePayeePaymentPrefWireMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeePaymentPrefWireMutation, GraphqlTypes.CreatePayeePaymentPrefWireMutationVariables>;
export const CreatePayeePaymentPrefCheckDocument = gql`
    mutation CreatePayeePaymentPrefCheck($input: CreateCheckPaymentPrefInput!) {
  createCheckPaymentPref(createCheckPaymentPrefInput: $input) {
    paymentPref {
      ...DetailedPaymentPref
    }
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;
export type CreatePayeePaymentPrefCheckMutationFn = Apollo.MutationFunction<GraphqlTypes.CreatePayeePaymentPrefCheckMutation, GraphqlTypes.CreatePayeePaymentPrefCheckMutationVariables>;

/**
 * __useCreatePayeePaymentPrefCheckMutation__
 *
 * To run a mutation, you first call `useCreatePayeePaymentPrefCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayeePaymentPrefCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayeePaymentPrefCheckMutation, { data, loading, error }] = useCreatePayeePaymentPrefCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayeePaymentPrefCheckMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreatePayeePaymentPrefCheckMutation, GraphqlTypes.CreatePayeePaymentPrefCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreatePayeePaymentPrefCheckMutation, GraphqlTypes.CreatePayeePaymentPrefCheckMutationVariables>(CreatePayeePaymentPrefCheckDocument, options);
      }
export type CreatePayeePaymentPrefCheckMutationHookResult = ReturnType<typeof useCreatePayeePaymentPrefCheckMutation>;
export type CreatePayeePaymentPrefCheckMutationResult = Apollo.MutationResult<GraphqlTypes.CreatePayeePaymentPrefCheckMutation>;
export type CreatePayeePaymentPrefCheckMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreatePayeePaymentPrefCheckMutation, GraphqlTypes.CreatePayeePaymentPrefCheckMutationVariables>;
export const FederatedCreateAchPaymentPrefDocument = gql`
    mutation FederatedCreateAchPaymentPref($input: CreateAchPaymentPrefInput!) {
  createAchPaymentPref(createAchPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateAchPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateAchPaymentPrefMutation, GraphqlTypes.FederatedCreateAchPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateAchPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateAchPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateAchPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateAchPaymentPrefMutation, { data, loading, error }] = useFederatedCreateAchPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateAchPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateAchPaymentPrefMutation, GraphqlTypes.FederatedCreateAchPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateAchPaymentPrefMutation, GraphqlTypes.FederatedCreateAchPaymentPrefMutationVariables>(FederatedCreateAchPaymentPrefDocument, options);
      }
export type FederatedCreateAchPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateAchPaymentPrefMutation>;
export type FederatedCreateAchPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateAchPaymentPrefMutation>;
export type FederatedCreateAchPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateAchPaymentPrefMutation, GraphqlTypes.FederatedCreateAchPaymentPrefMutationVariables>;
export const FederatedCreateWirePaymentPrefDocument = gql`
    mutation FederatedCreateWirePaymentPref($input: CreateWirePaymentPrefInput!) {
  createWirePaymentPref(createWirePaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateWirePaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateWirePaymentPrefMutation, GraphqlTypes.FederatedCreateWirePaymentPrefMutationVariables>;

/**
 * __useFederatedCreateWirePaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateWirePaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateWirePaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateWirePaymentPrefMutation, { data, loading, error }] = useFederatedCreateWirePaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateWirePaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateWirePaymentPrefMutation, GraphqlTypes.FederatedCreateWirePaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateWirePaymentPrefMutation, GraphqlTypes.FederatedCreateWirePaymentPrefMutationVariables>(FederatedCreateWirePaymentPrefDocument, options);
      }
export type FederatedCreateWirePaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateWirePaymentPrefMutation>;
export type FederatedCreateWirePaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateWirePaymentPrefMutation>;
export type FederatedCreateWirePaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateWirePaymentPrefMutation, GraphqlTypes.FederatedCreateWirePaymentPrefMutationVariables>;
export const FederatedCreateCheckPaymentPrefDocument = gql`
    mutation FederatedCreateCheckPaymentPref($input: CreateCheckPaymentPrefInput!) {
  createCheckPaymentPref(createCheckPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateCheckPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateCheckPaymentPrefMutation, GraphqlTypes.FederatedCreateCheckPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateCheckPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateCheckPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateCheckPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateCheckPaymentPrefMutation, { data, loading, error }] = useFederatedCreateCheckPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateCheckPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateCheckPaymentPrefMutation, GraphqlTypes.FederatedCreateCheckPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateCheckPaymentPrefMutation, GraphqlTypes.FederatedCreateCheckPaymentPrefMutationVariables>(FederatedCreateCheckPaymentPrefDocument, options);
      }
export type FederatedCreateCheckPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateCheckPaymentPrefMutation>;
export type FederatedCreateCheckPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateCheckPaymentPrefMutation>;
export type FederatedCreateCheckPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateCheckPaymentPrefMutation, GraphqlTypes.FederatedCreateCheckPaymentPrefMutationVariables>;
export const FederatedCreateBecsPaymentPrefDocument = gql`
    mutation FederatedCreateBecsPaymentPref($input: CreateBecsPaymentPrefInput!) {
  createBecsPaymentPref(createBecsPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateBecsPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateBecsPaymentPrefMutation, GraphqlTypes.FederatedCreateBecsPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateBecsPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateBecsPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateBecsPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateBecsPaymentPrefMutation, { data, loading, error }] = useFederatedCreateBecsPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateBecsPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateBecsPaymentPrefMutation, GraphqlTypes.FederatedCreateBecsPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateBecsPaymentPrefMutation, GraphqlTypes.FederatedCreateBecsPaymentPrefMutationVariables>(FederatedCreateBecsPaymentPrefDocument, options);
      }
export type FederatedCreateBecsPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateBecsPaymentPrefMutation>;
export type FederatedCreateBecsPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateBecsPaymentPrefMutation>;
export type FederatedCreateBecsPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateBecsPaymentPrefMutation, GraphqlTypes.FederatedCreateBecsPaymentPrefMutationVariables>;
export const FederatedCreateBacsPaymentPrefDocument = gql`
    mutation FederatedCreateBacsPaymentPref($input: CreateBacsPaymentPrefInput!) {
  createBacsPaymentPref(createBacsPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateBacsPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateBacsPaymentPrefMutation, GraphqlTypes.FederatedCreateBacsPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateBacsPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateBacsPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateBacsPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateBacsPaymentPrefMutation, { data, loading, error }] = useFederatedCreateBacsPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateBacsPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateBacsPaymentPrefMutation, GraphqlTypes.FederatedCreateBacsPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateBacsPaymentPrefMutation, GraphqlTypes.FederatedCreateBacsPaymentPrefMutationVariables>(FederatedCreateBacsPaymentPrefDocument, options);
      }
export type FederatedCreateBacsPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateBacsPaymentPrefMutation>;
export type FederatedCreateBacsPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateBacsPaymentPrefMutation>;
export type FederatedCreateBacsPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateBacsPaymentPrefMutation, GraphqlTypes.FederatedCreateBacsPaymentPrefMutationVariables>;
export const FederatedCreateSepaPaymentPrefDocument = gql`
    mutation FederatedCreateSepaPaymentPref($input: CreateSepaPaymentPrefInput!) {
  createSepaPaymentPref(createSepaPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateSepaPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateSepaPaymentPrefMutation, GraphqlTypes.FederatedCreateSepaPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateSepaPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateSepaPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateSepaPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateSepaPaymentPrefMutation, { data, loading, error }] = useFederatedCreateSepaPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateSepaPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateSepaPaymentPrefMutation, GraphqlTypes.FederatedCreateSepaPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateSepaPaymentPrefMutation, GraphqlTypes.FederatedCreateSepaPaymentPrefMutationVariables>(FederatedCreateSepaPaymentPrefDocument, options);
      }
export type FederatedCreateSepaPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateSepaPaymentPrefMutation>;
export type FederatedCreateSepaPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateSepaPaymentPrefMutation>;
export type FederatedCreateSepaPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateSepaPaymentPrefMutation, GraphqlTypes.FederatedCreateSepaPaymentPrefMutationVariables>;
export const FederatedCreateEftPaymentPrefDocument = gql`
    mutation FederatedCreateEftPaymentPref($input: CreateEftPaymentPrefInput!) {
  createEftPaymentPref(createEftPaymentPrefInput: $input) {
    paymentPref {
      ...FederatedCreatePaymentPrefFragment
    }
  }
}
    ${FederatedCreatePaymentPrefFragmentFragmentDoc}`;
export type FederatedCreateEftPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateEftPaymentPrefMutation, GraphqlTypes.FederatedCreateEftPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateEftPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateEftPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateEftPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateEftPaymentPrefMutation, { data, loading, error }] = useFederatedCreateEftPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateEftPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateEftPaymentPrefMutation, GraphqlTypes.FederatedCreateEftPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateEftPaymentPrefMutation, GraphqlTypes.FederatedCreateEftPaymentPrefMutationVariables>(FederatedCreateEftPaymentPrefDocument, options);
      }
export type FederatedCreateEftPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateEftPaymentPrefMutation>;
export type FederatedCreateEftPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateEftPaymentPrefMutation>;
export type FederatedCreateEftPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateEftPaymentPrefMutation, GraphqlTypes.FederatedCreateEftPaymentPrefMutationVariables>;
export const FederatedCreateOtherPaymentPrefDocument = gql`
    mutation FederatedCreateOtherPaymentPref($input: CreateOtherPaymentPrefInput!) {
  createOtherPaymentPref(createOtherPaymentPrefInput: $input) {
    paymentPref {
      id
    }
  }
}
    `;
export type FederatedCreateOtherPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.FederatedCreateOtherPaymentPrefMutation, GraphqlTypes.FederatedCreateOtherPaymentPrefMutationVariables>;

/**
 * __useFederatedCreateOtherPaymentPrefMutation__
 *
 * To run a mutation, you first call `useFederatedCreateOtherPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFederatedCreateOtherPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [federatedCreateOtherPaymentPrefMutation, { data, loading, error }] = useFederatedCreateOtherPaymentPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFederatedCreateOtherPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FederatedCreateOtherPaymentPrefMutation, GraphqlTypes.FederatedCreateOtherPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FederatedCreateOtherPaymentPrefMutation, GraphqlTypes.FederatedCreateOtherPaymentPrefMutationVariables>(FederatedCreateOtherPaymentPrefDocument, options);
      }
export type FederatedCreateOtherPaymentPrefMutationHookResult = ReturnType<typeof useFederatedCreateOtherPaymentPrefMutation>;
export type FederatedCreateOtherPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.FederatedCreateOtherPaymentPrefMutation>;
export type FederatedCreateOtherPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FederatedCreateOtherPaymentPrefMutation, GraphqlTypes.FederatedCreateOtherPaymentPrefMutationVariables>;
export const UpdatePaymentPrefForPositionsOfPaymentPrefDocument = gql`
    mutation UpdatePaymentPrefForPositionsOfPaymentPref($objectInput: UpdatePaymentPrefForPositionsOfPaymentPrefInput!) {
  updatePaymentPrefForPositionsOfPaymentPref(objectInput: $objectInput) {
    __typename
  }
}
    `;
export type UpdatePaymentPrefForPositionsOfPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutationVariables>;

/**
 * __useUpdatePaymentPrefForPositionsOfPaymentPrefMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefForPositionsOfPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefForPositionsOfPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefForPositionsOfPaymentPrefMutation, { data, loading, error }] = useUpdatePaymentPrefForPositionsOfPaymentPrefMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefForPositionsOfPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutationVariables>(UpdatePaymentPrefForPositionsOfPaymentPrefDocument, options);
      }
export type UpdatePaymentPrefForPositionsOfPaymentPrefMutationHookResult = ReturnType<typeof useUpdatePaymentPrefForPositionsOfPaymentPrefMutation>;
export type UpdatePaymentPrefForPositionsOfPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutation>;
export type UpdatePaymentPrefForPositionsOfPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutation, GraphqlTypes.UpdatePaymentPrefForPositionsOfPaymentPrefMutationVariables>;
export const UpdatePaymentPrefForPositionsInAccountDocument = gql`
    mutation UpdatePaymentPrefForPositionsInAccount($objectInput: UpdatePaymentPrefForAccountsInput!) {
  updatePaymentPrefForAccounts(objectInput: $objectInput) {
    __typename
  }
}
    `;
export type UpdatePaymentPrefForPositionsInAccountMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutation, GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutationVariables>;

/**
 * __useUpdatePaymentPrefForPositionsInAccountMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefForPositionsInAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefForPositionsInAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefForPositionsInAccountMutation, { data, loading, error }] = useUpdatePaymentPrefForPositionsInAccountMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefForPositionsInAccountMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutation, GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutation, GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutationVariables>(UpdatePaymentPrefForPositionsInAccountDocument, options);
      }
export type UpdatePaymentPrefForPositionsInAccountMutationHookResult = ReturnType<typeof useUpdatePaymentPrefForPositionsInAccountMutation>;
export type UpdatePaymentPrefForPositionsInAccountMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutation>;
export type UpdatePaymentPrefForPositionsInAccountMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutation, GraphqlTypes.UpdatePaymentPrefForPositionsInAccountMutationVariables>;
export const UpdatePaymentPrefForSinglePositionDocument = gql`
    mutation updatePaymentPrefForSinglePosition($objectInput: UpdatePaymentPrefForPositionInput!) {
  updatePaymentPrefForPosition(objectInput: $objectInput) {
    __typename
  }
}
    `;
export type UpdatePaymentPrefForSinglePositionMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefForSinglePositionMutation, GraphqlTypes.UpdatePaymentPrefForSinglePositionMutationVariables>;

/**
 * __useUpdatePaymentPrefForSinglePositionMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefForSinglePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefForSinglePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefForSinglePositionMutation, { data, loading, error }] = useUpdatePaymentPrefForSinglePositionMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefForSinglePositionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefForSinglePositionMutation, GraphqlTypes.UpdatePaymentPrefForSinglePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefForSinglePositionMutation, GraphqlTypes.UpdatePaymentPrefForSinglePositionMutationVariables>(UpdatePaymentPrefForSinglePositionDocument, options);
      }
export type UpdatePaymentPrefForSinglePositionMutationHookResult = ReturnType<typeof useUpdatePaymentPrefForSinglePositionMutation>;
export type UpdatePaymentPrefForSinglePositionMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefForSinglePositionMutation>;
export type UpdatePaymentPrefForSinglePositionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefForSinglePositionMutation, GraphqlTypes.UpdatePaymentPrefForSinglePositionMutationVariables>;
export const UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsDocument = gql`
    mutation updatePaymentPrefsForPositionsInAccountWithoutPaymentPrefs($objectInput: UpdatePaymentPrefForPositionsWithoutPaymentPrefInput!) {
  updatePaymentPrefForPositionsWithoutPaymentPref(objectInput: $objectInput) {
    __typename
  }
}
    `;
export type UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation, GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationVariables>;

/**
 * __useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation, { data, loading, error }] = useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation({
 *   variables: {
 *      objectInput: // value for 'objectInput'
 *   },
 * });
 */
export function useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation, GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation, GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationVariables>(UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsDocument, options);
      }
export type UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationHookResult = ReturnType<typeof useUpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation>;
export type UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation>;
export type UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutation, GraphqlTypes.UpdatePaymentPrefsForPositionsInAccountWithoutPaymentPrefsMutationVariables>;
export const SubmitChangeRequestPaymentPrefDocument = gql`
    mutation submitChangeRequestPaymentPref($payloads: [ChangeRequestPayload!]!, $metadata: JSON) {
  submitChangeRequest(
    objectInput: {requestType: UPDATE_POSITION_PAYMENT_PREF, requestPayloads: $payloads, metadata: $metadata}
  ) {
    ... on SubmitChangeRequestResponse {
      responses {
        requestId
        requestType
        requestPayload
        actions
        status
      }
    }
    ... on MutationErrorResponse {
      errorCode
      message
    }
  }
}
    `;
export type SubmitChangeRequestPaymentPrefMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitChangeRequestPaymentPrefMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefMutationVariables>;

/**
 * __useSubmitChangeRequestPaymentPrefMutation__
 *
 * To run a mutation, you first call `useSubmitChangeRequestPaymentPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitChangeRequestPaymentPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitChangeRequestPaymentPrefMutation, { data, loading, error }] = useSubmitChangeRequestPaymentPrefMutation({
 *   variables: {
 *      payloads: // value for 'payloads'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useSubmitChangeRequestPaymentPrefMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitChangeRequestPaymentPrefMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitChangeRequestPaymentPrefMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefMutationVariables>(SubmitChangeRequestPaymentPrefDocument, options);
      }
export type SubmitChangeRequestPaymentPrefMutationHookResult = ReturnType<typeof useSubmitChangeRequestPaymentPrefMutation>;
export type SubmitChangeRequestPaymentPrefMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitChangeRequestPaymentPrefMutation>;
export type SubmitChangeRequestPaymentPrefMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitChangeRequestPaymentPrefMutation, GraphqlTypes.SubmitChangeRequestPaymentPrefMutationVariables>;
export const GetPaginatedPositionsInAccountWithFiltersDocument = gql`
    query GetPaginatedPositionsInAccountWithFilters($accountId: ID!, $first: Int, $filters: PositionArgumentFilters, $after: String) {
  account(accountId: $accountId) {
    id
    positions(filters: $filters, first: $first, after: $after) {
      __typename
      count
      edges {
        __typename
        cursor
        node {
          __typename
          id
          investmentEntity {
            __typename
            id
            name
          }
        }
      }
      pageInfo {
        __typename
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedPositionsInAccountWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedPositionsInAccountWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedPositionsInAccountWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedPositionsInAccountWithFiltersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPaginatedPositionsInAccountWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables> & ({ variables: GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>(GetPaginatedPositionsInAccountWithFiltersDocument, options);
      }
export function useGetPaginatedPositionsInAccountWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>(GetPaginatedPositionsInAccountWithFiltersDocument, options);
        }
// @ts-ignore
export function useGetPaginatedPositionsInAccountWithFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>;
export function useGetPaginatedPositionsInAccountWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery | undefined, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>;
export function useGetPaginatedPositionsInAccountWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>(GetPaginatedPositionsInAccountWithFiltersDocument, options);
        }
export type GetPaginatedPositionsInAccountWithFiltersQueryHookResult = ReturnType<typeof useGetPaginatedPositionsInAccountWithFiltersQuery>;
export type GetPaginatedPositionsInAccountWithFiltersLazyQueryHookResult = ReturnType<typeof useGetPaginatedPositionsInAccountWithFiltersLazyQuery>;
export type GetPaginatedPositionsInAccountWithFiltersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedPositionsInAccountWithFiltersSuspenseQuery>;
export type GetPaginatedPositionsInAccountWithFiltersQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQuery, GraphqlTypes.GetPaginatedPositionsInAccountWithFiltersQueryVariables>;
export const GetPositionsOfPaymentPrefDocument = gql`
    query GetPositionsOfPaymentPref($id: ID!, $first: Int, $after: String) {
  paymentPrefs(paymentPrefIds: [$id]) {
    id
    positionsPaginated(first: $first, after: $after) {
      count
      edges {
        cursor
        node {
          id
          investmentEntity {
            id
            name
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetPositionsOfPaymentPrefQuery__
 *
 * To run a query within a React component, call `useGetPositionsOfPaymentPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsOfPaymentPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsOfPaymentPrefQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPositionsOfPaymentPrefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables> & ({ variables: GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>(GetPositionsOfPaymentPrefDocument, options);
      }
export function useGetPositionsOfPaymentPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>(GetPositionsOfPaymentPrefDocument, options);
        }
// @ts-ignore
export function useGetPositionsOfPaymentPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>;
export function useGetPositionsOfPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsOfPaymentPrefQuery | undefined, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>;
export function useGetPositionsOfPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>(GetPositionsOfPaymentPrefDocument, options);
        }
export type GetPositionsOfPaymentPrefQueryHookResult = ReturnType<typeof useGetPositionsOfPaymentPrefQuery>;
export type GetPositionsOfPaymentPrefLazyQueryHookResult = ReturnType<typeof useGetPositionsOfPaymentPrefLazyQuery>;
export type GetPositionsOfPaymentPrefSuspenseQueryHookResult = ReturnType<typeof useGetPositionsOfPaymentPrefSuspenseQuery>;
export type GetPositionsOfPaymentPrefQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsOfPaymentPrefQuery, GraphqlTypes.GetPositionsOfPaymentPrefQueryVariables>;
export const GetPositionsOfAccountWithoutPaymentPrefDocument = gql`
    query GetPositionsOfAccountWithoutPaymentPref($id: ID!, $first: Int, $after: String, $includeDeletedAccount: Boolean = false) {
  account(accountId: $id, includeDeleted: $includeDeletedAccount) {
    id
    positions(first: $first, after: $after, filters: {hasPaymentPref: false}) {
      count
      edges {
        cursor
        node {
          id
          investmentEntity {
            id
            name
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useGetPositionsOfAccountWithoutPaymentPrefQuery__
 *
 * To run a query within a React component, call `useGetPositionsOfAccountWithoutPaymentPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsOfAccountWithoutPaymentPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsOfAccountWithoutPaymentPrefQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      includeDeletedAccount: // value for 'includeDeletedAccount'
 *   },
 * });
 */
export function useGetPositionsOfAccountWithoutPaymentPrefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables> & ({ variables: GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>(GetPositionsOfAccountWithoutPaymentPrefDocument, options);
      }
export function useGetPositionsOfAccountWithoutPaymentPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>(GetPositionsOfAccountWithoutPaymentPrefDocument, options);
        }
// @ts-ignore
export function useGetPositionsOfAccountWithoutPaymentPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>;
export function useGetPositionsOfAccountWithoutPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery | undefined, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>;
export function useGetPositionsOfAccountWithoutPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>(GetPositionsOfAccountWithoutPaymentPrefDocument, options);
        }
export type GetPositionsOfAccountWithoutPaymentPrefQueryHookResult = ReturnType<typeof useGetPositionsOfAccountWithoutPaymentPrefQuery>;
export type GetPositionsOfAccountWithoutPaymentPrefLazyQueryHookResult = ReturnType<typeof useGetPositionsOfAccountWithoutPaymentPrefLazyQuery>;
export type GetPositionsOfAccountWithoutPaymentPrefSuspenseQueryHookResult = ReturnType<typeof useGetPositionsOfAccountWithoutPaymentPrefSuspenseQuery>;
export type GetPositionsOfAccountWithoutPaymentPrefQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQuery, GraphqlTypes.GetPositionsOfAccountWithoutPaymentPrefQueryVariables>;
export const GetAccountPaymentPrefsDocument = gql`
    query GetAccountPaymentPrefs($includeDeleted: Boolean = false, $accountId: ID!) {
  currentUser {
    id
    canEditPaymentPrefsForAccountPermission(accountId: $accountId)
    canRevealPaymentPrefPermission
  }
  account(includeDeleted: $includeDeleted, accountId: $accountId) {
    id
    name
    paymentPrefs {
      id
      ...RedactedPaymentPref
    }
  }
}
    ${RedactedPaymentPrefFragmentDoc}`;

/**
 * __useGetAccountPaymentPrefsQuery__
 *
 * To run a query within a React component, call `useGetAccountPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountPaymentPrefsQuery({
 *   variables: {
 *      includeDeleted: // value for 'includeDeleted'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountPaymentPrefsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables> & ({ variables: GraphqlTypes.GetAccountPaymentPrefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>(GetAccountPaymentPrefsDocument, options);
      }
export function useGetAccountPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>(GetAccountPaymentPrefsDocument, options);
        }
// @ts-ignore
export function useGetAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>;
export function useGetAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountPaymentPrefsQuery | undefined, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>;
export function useGetAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>(GetAccountPaymentPrefsDocument, options);
        }
export type GetAccountPaymentPrefsQueryHookResult = ReturnType<typeof useGetAccountPaymentPrefsQuery>;
export type GetAccountPaymentPrefsLazyQueryHookResult = ReturnType<typeof useGetAccountPaymentPrefsLazyQuery>;
export type GetAccountPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof useGetAccountPaymentPrefsSuspenseQuery>;
export type GetAccountPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountPaymentPrefsQuery, GraphqlTypes.GetAccountPaymentPrefsQueryVariables>;
export const GetCurrentUserCanEditPaymentPrefForPositionsDocument = gql`
    query GetCurrentUserCanEditPaymentPrefForPositions($accountId: ID!) {
  currentUser {
    id
    canEditPaymentPrefsForAccountPermission(accountId: $accountId)
    canRevealPaymentPrefPermission
  }
}
    `;

/**
 * __useGetCurrentUserCanEditPaymentPrefForPositionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCanEditPaymentPrefForPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCanEditPaymentPrefForPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCanEditPaymentPrefForPositionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetCurrentUserCanEditPaymentPrefForPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables> & ({ variables: GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>(GetCurrentUserCanEditPaymentPrefForPositionsDocument, options);
      }
export function useGetCurrentUserCanEditPaymentPrefForPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>(GetCurrentUserCanEditPaymentPrefForPositionsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserCanEditPaymentPrefForPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>;
export function useGetCurrentUserCanEditPaymentPrefForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery | undefined, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>;
export function useGetCurrentUserCanEditPaymentPrefForPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>(GetCurrentUserCanEditPaymentPrefForPositionsDocument, options);
        }
export type GetCurrentUserCanEditPaymentPrefForPositionsQueryHookResult = ReturnType<typeof useGetCurrentUserCanEditPaymentPrefForPositionsQuery>;
export type GetCurrentUserCanEditPaymentPrefForPositionsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCanEditPaymentPrefForPositionsLazyQuery>;
export type GetCurrentUserCanEditPaymentPrefForPositionsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCanEditPaymentPrefForPositionsSuspenseQuery>;
export type GetCurrentUserCanEditPaymentPrefForPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQuery, GraphqlTypes.GetCurrentUserCanEditPaymentPrefForPositionsQueryVariables>;
export const GetConsolidatedPaymentPrefForPositionDocument = gql`
    query GetConsolidatedPaymentPrefForPosition($paymentPrefIds: [ID!]!) {
  paymentPrefs(paymentPrefIds: $paymentPrefIds) {
    ...RedactedPaymentPref
  }
}
    ${RedactedPaymentPrefFragmentDoc}`;

/**
 * __useGetConsolidatedPaymentPrefForPositionQuery__
 *
 * To run a query within a React component, call `useGetConsolidatedPaymentPrefForPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsolidatedPaymentPrefForPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsolidatedPaymentPrefForPositionQuery({
 *   variables: {
 *      paymentPrefIds: // value for 'paymentPrefIds'
 *   },
 * });
 */
export function useGetConsolidatedPaymentPrefForPositionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables> & ({ variables: GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>(GetConsolidatedPaymentPrefForPositionDocument, options);
      }
export function useGetConsolidatedPaymentPrefForPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>(GetConsolidatedPaymentPrefForPositionDocument, options);
        }
// @ts-ignore
export function useGetConsolidatedPaymentPrefForPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>;
export function useGetConsolidatedPaymentPrefForPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery | undefined, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>;
export function useGetConsolidatedPaymentPrefForPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>(GetConsolidatedPaymentPrefForPositionDocument, options);
        }
export type GetConsolidatedPaymentPrefForPositionQueryHookResult = ReturnType<typeof useGetConsolidatedPaymentPrefForPositionQuery>;
export type GetConsolidatedPaymentPrefForPositionLazyQueryHookResult = ReturnType<typeof useGetConsolidatedPaymentPrefForPositionLazyQuery>;
export type GetConsolidatedPaymentPrefForPositionSuspenseQueryHookResult = ReturnType<typeof useGetConsolidatedPaymentPrefForPositionSuspenseQuery>;
export type GetConsolidatedPaymentPrefForPositionQueryResult = Apollo.QueryResult<GraphqlTypes.GetConsolidatedPaymentPrefForPositionQuery, GraphqlTypes.GetConsolidatedPaymentPrefForPositionQueryVariables>;
export const GetAccountNameDocument = gql`
    query GetAccountName($accountId: ID!) {
  account(accountId: $accountId) {
    id
    name
  }
}
    `;

/**
 * __useGetAccountNameQuery__
 *
 * To run a query within a React component, call `useGetAccountNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables> & ({ variables: GraphqlTypes.GetAccountNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>(GetAccountNameDocument, options);
      }
export function useGetAccountNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>(GetAccountNameDocument, options);
        }
// @ts-ignore
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>;
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountNameQuery | undefined, GraphqlTypes.GetAccountNameQueryVariables>;
export function useGetAccountNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>(GetAccountNameDocument, options);
        }
export type GetAccountNameQueryHookResult = ReturnType<typeof useGetAccountNameQuery>;
export type GetAccountNameLazyQueryHookResult = ReturnType<typeof useGetAccountNameLazyQuery>;
export type GetAccountNameSuspenseQueryHookResult = ReturnType<typeof useGetAccountNameSuspenseQuery>;
export type GetAccountNameQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountNameQuery, GraphqlTypes.GetAccountNameQueryVariables>;
export const GetExistingAccountPaymentPrefsDocument = gql`
    query GetExistingAccountPaymentPrefs($accountId: ID!) {
  account(accountId: $accountId) {
    id
    name
    paymentPrefs {
      ...RedactedPaymentPref
    }
  }
}
    ${RedactedPaymentPrefFragmentDoc}`;

/**
 * __useGetExistingAccountPaymentPrefsQuery__
 *
 * To run a query within a React component, call `useGetExistingAccountPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingAccountPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingAccountPaymentPrefsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetExistingAccountPaymentPrefsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables> & ({ variables: GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>(GetExistingAccountPaymentPrefsDocument, options);
      }
export function useGetExistingAccountPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>(GetExistingAccountPaymentPrefsDocument, options);
        }
// @ts-ignore
export function useGetExistingAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>;
export function useGetExistingAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsQuery | undefined, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>;
export function useGetExistingAccountPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>(GetExistingAccountPaymentPrefsDocument, options);
        }
export type GetExistingAccountPaymentPrefsQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsQuery>;
export type GetExistingAccountPaymentPrefsLazyQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsLazyQuery>;
export type GetExistingAccountPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsSuspenseQuery>;
export type GetExistingAccountPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsQuery, GraphqlTypes.GetExistingAccountPaymentPrefsQueryVariables>;
export const GetSupportedPaymentMethodsForAccountPositionsDocument = gql`
    query GetSupportedPaymentMethodsForAccountPositions($accountId: ID!, $filters: PositionArgumentFilters) {
  account(accountId: $accountId) {
    id
    positions(filters: $filters) {
      edges {
        node {
          id
          investmentEntity {
            id
            supportedPaymentMethods
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSupportedPaymentMethodsForAccountPositionsQuery__
 *
 * To run a query within a React component, call `useGetSupportedPaymentMethodsForAccountPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedPaymentMethodsForAccountPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedPaymentMethodsForAccountPositionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSupportedPaymentMethodsForAccountPositionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables> & ({ variables: GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>(GetSupportedPaymentMethodsForAccountPositionsDocument, options);
      }
export function useGetSupportedPaymentMethodsForAccountPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>(GetSupportedPaymentMethodsForAccountPositionsDocument, options);
        }
// @ts-ignore
export function useGetSupportedPaymentMethodsForAccountPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>;
export function useGetSupportedPaymentMethodsForAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery | undefined, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>;
export function useGetSupportedPaymentMethodsForAccountPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>(GetSupportedPaymentMethodsForAccountPositionsDocument, options);
        }
export type GetSupportedPaymentMethodsForAccountPositionsQueryHookResult = ReturnType<typeof useGetSupportedPaymentMethodsForAccountPositionsQuery>;
export type GetSupportedPaymentMethodsForAccountPositionsLazyQueryHookResult = ReturnType<typeof useGetSupportedPaymentMethodsForAccountPositionsLazyQuery>;
export type GetSupportedPaymentMethodsForAccountPositionsSuspenseQueryHookResult = ReturnType<typeof useGetSupportedPaymentMethodsForAccountPositionsSuspenseQuery>;
export type GetSupportedPaymentMethodsForAccountPositionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQuery, GraphqlTypes.GetSupportedPaymentMethodsForAccountPositionsQueryVariables>;
export const ArenaPayeeSupportedPaymentMethodsDocument = gql`
    query ArenaPayeeSupportedPaymentMethods($arenaId: ID!) {
  arenas(arenaIds: [$arenaId]) {
    edges {
      node {
        id
        features {
          hasPositionPaymentPrefStaffApprovals
        }
        payeeSupportedPaymentMethods
      }
    }
  }
}
    `;

/**
 * __useArenaPayeeSupportedPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useArenaPayeeSupportedPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArenaPayeeSupportedPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArenaPayeeSupportedPaymentMethodsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useArenaPayeeSupportedPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables> & ({ variables: GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>(ArenaPayeeSupportedPaymentMethodsDocument, options);
      }
export function useArenaPayeeSupportedPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>(ArenaPayeeSupportedPaymentMethodsDocument, options);
        }
// @ts-ignore
export function useArenaPayeeSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>;
export function useArenaPayeeSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery | undefined, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>;
export function useArenaPayeeSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>(ArenaPayeeSupportedPaymentMethodsDocument, options);
        }
export type ArenaPayeeSupportedPaymentMethodsQueryHookResult = ReturnType<typeof useArenaPayeeSupportedPaymentMethodsQuery>;
export type ArenaPayeeSupportedPaymentMethodsLazyQueryHookResult = ReturnType<typeof useArenaPayeeSupportedPaymentMethodsLazyQuery>;
export type ArenaPayeeSupportedPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useArenaPayeeSupportedPaymentMethodsSuspenseQuery>;
export type ArenaPayeeSupportedPaymentMethodsQueryResult = Apollo.QueryResult<GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQuery, GraphqlTypes.ArenaPayeeSupportedPaymentMethodsQueryVariables>;
export const GetExistingAccountPaymentPrefsForCreateDocument = gql`
    query GetExistingAccountPaymentPrefsForCreate($accountId: ID!, $positionId: ID, $accountIds: [ID!], $paymentPrefIds: [ID!]) {
  account(accountId: $accountId) {
    id
    name
    paymentPrefs {
      ...RedactedPaymentPref
      ...CompatibilityWithPositions
    }
  }
}
    ${RedactedPaymentPrefFragmentDoc}
${CompatibilityWithPositionsFragmentDoc}`;

/**
 * __useGetExistingAccountPaymentPrefsForCreateQuery__
 *
 * To run a query within a React component, call `useGetExistingAccountPaymentPrefsForCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingAccountPaymentPrefsForCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingAccountPaymentPrefsForCreateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      positionId: // value for 'positionId'
 *      accountIds: // value for 'accountIds'
 *      paymentPrefIds: // value for 'paymentPrefIds'
 *   },
 * });
 */
export function useGetExistingAccountPaymentPrefsForCreateQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables> & ({ variables: GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>(GetExistingAccountPaymentPrefsForCreateDocument, options);
      }
export function useGetExistingAccountPaymentPrefsForCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>(GetExistingAccountPaymentPrefsForCreateDocument, options);
        }
// @ts-ignore
export function useGetExistingAccountPaymentPrefsForCreateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>;
export function useGetExistingAccountPaymentPrefsForCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery | undefined, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>;
export function useGetExistingAccountPaymentPrefsForCreateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>(GetExistingAccountPaymentPrefsForCreateDocument, options);
        }
export type GetExistingAccountPaymentPrefsForCreateQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsForCreateQuery>;
export type GetExistingAccountPaymentPrefsForCreateLazyQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsForCreateLazyQuery>;
export type GetExistingAccountPaymentPrefsForCreateSuspenseQueryHookResult = ReturnType<typeof useGetExistingAccountPaymentPrefsForCreateSuspenseQuery>;
export type GetExistingAccountPaymentPrefsForCreateQueryResult = Apollo.QueryResult<GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQuery, GraphqlTypes.GetExistingAccountPaymentPrefsForCreateQueryVariables>;
export const GetDedupedPaymentPrefsDocument = gql`
    query GetDedupedPaymentPrefs($positionId: ID, $accountIds: [ID!], $paymentPrefIds: [ID!]) {
  dedupedPaymentPrefs {
    id
    ...RedactedPaymentPref
    ...CompatibilityWithPositions
  }
}
    ${RedactedPaymentPrefFragmentDoc}
${CompatibilityWithPositionsFragmentDoc}`;

/**
 * __useGetDedupedPaymentPrefsQuery__
 *
 * To run a query within a React component, call `useGetDedupedPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDedupedPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDedupedPaymentPrefsQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      accountIds: // value for 'accountIds'
 *      paymentPrefIds: // value for 'paymentPrefIds'
 *   },
 * });
 */
export function useGetDedupedPaymentPrefsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>(GetDedupedPaymentPrefsDocument, options);
      }
export function useGetDedupedPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>(GetDedupedPaymentPrefsDocument, options);
        }
// @ts-ignore
export function useGetDedupedPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>;
export function useGetDedupedPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDedupedPaymentPrefsQuery | undefined, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>;
export function useGetDedupedPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>(GetDedupedPaymentPrefsDocument, options);
        }
export type GetDedupedPaymentPrefsQueryHookResult = ReturnType<typeof useGetDedupedPaymentPrefsQuery>;
export type GetDedupedPaymentPrefsLazyQueryHookResult = ReturnType<typeof useGetDedupedPaymentPrefsLazyQuery>;
export type GetDedupedPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof useGetDedupedPaymentPrefsSuspenseQuery>;
export type GetDedupedPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.GetDedupedPaymentPrefsQuery, GraphqlTypes.GetDedupedPaymentPrefsQueryVariables>;
export const PositionWorkflowPaymentPrefsDocument = gql`
    query PositionWorkflowPaymentPrefs($accountId: ID!, $positionId: ID, $accountIds: [ID!], $paymentPrefIds: [ID!]) {
  account(accountId: $accountId) {
    id
    name
    paymentPrefs {
      ...RedactedPaymentPref
      ...CompatibilityWithPositions
    }
  }
}
    ${RedactedPaymentPrefFragmentDoc}
${CompatibilityWithPositionsFragmentDoc}`;

/**
 * __usePositionWorkflowPaymentPrefsQuery__
 *
 * To run a query within a React component, call `usePositionWorkflowPaymentPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionWorkflowPaymentPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionWorkflowPaymentPrefsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      positionId: // value for 'positionId'
 *      accountIds: // value for 'accountIds'
 *      paymentPrefIds: // value for 'paymentPrefIds'
 *   },
 * });
 */
export function usePositionWorkflowPaymentPrefsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables> & ({ variables: GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>(PositionWorkflowPaymentPrefsDocument, options);
      }
export function usePositionWorkflowPaymentPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>(PositionWorkflowPaymentPrefsDocument, options);
        }
// @ts-ignore
export function usePositionWorkflowPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>;
export function usePositionWorkflowPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionWorkflowPaymentPrefsQuery | undefined, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>;
export function usePositionWorkflowPaymentPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>(PositionWorkflowPaymentPrefsDocument, options);
        }
export type PositionWorkflowPaymentPrefsQueryHookResult = ReturnType<typeof usePositionWorkflowPaymentPrefsQuery>;
export type PositionWorkflowPaymentPrefsLazyQueryHookResult = ReturnType<typeof usePositionWorkflowPaymentPrefsLazyQuery>;
export type PositionWorkflowPaymentPrefsSuspenseQueryHookResult = ReturnType<typeof usePositionWorkflowPaymentPrefsSuspenseQuery>;
export type PositionWorkflowPaymentPrefsQueryResult = Apollo.QueryResult<GraphqlTypes.PositionWorkflowPaymentPrefsQuery, GraphqlTypes.PositionWorkflowPaymentPrefsQueryVariables>;
export const PositionWorkflowSupportedPaymentMethodsDocument = gql`
    query PositionWorkflowSupportedPaymentMethods($entityId: ID!) {
  investmentEntity(entityId: $entityId) {
    id
    supportedPaymentMethods
  }
}
    `;

/**
 * __usePositionWorkflowSupportedPaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePositionWorkflowSupportedPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionWorkflowSupportedPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionWorkflowSupportedPaymentMethodsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function usePositionWorkflowSupportedPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables> & ({ variables: GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>(PositionWorkflowSupportedPaymentMethodsDocument, options);
      }
export function usePositionWorkflowSupportedPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>(PositionWorkflowSupportedPaymentMethodsDocument, options);
        }
// @ts-ignore
export function usePositionWorkflowSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>;
export function usePositionWorkflowSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery | undefined, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>;
export function usePositionWorkflowSupportedPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>(PositionWorkflowSupportedPaymentMethodsDocument, options);
        }
export type PositionWorkflowSupportedPaymentMethodsQueryHookResult = ReturnType<typeof usePositionWorkflowSupportedPaymentMethodsQuery>;
export type PositionWorkflowSupportedPaymentMethodsLazyQueryHookResult = ReturnType<typeof usePositionWorkflowSupportedPaymentMethodsLazyQuery>;
export type PositionWorkflowSupportedPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof usePositionWorkflowSupportedPaymentMethodsSuspenseQuery>;
export type PositionWorkflowSupportedPaymentMethodsQueryResult = Apollo.QueryResult<GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQuery, GraphqlTypes.PositionWorkflowSupportedPaymentMethodsQueryVariables>;
export const AvailablePaymentRailsDocument = gql`
    query AvailablePaymentRails($positionId: ID, $accountIds: [ID!], $paymentPrefIds: [ID!], $countryId: ID, $isLpPortal: Boolean, $subscriptionId: ID) {
  availablePaymentRails(
    positionId: $positionId
    accountIds: $accountIds
    paymentPrefIds: $paymentPrefIds
    countryId: $countryId
    isLpPortal: $isLpPortal
    subscriptionId: $subscriptionId
  ) {
    requiresCountrySelection
    totalPositions
    rails {
      railCode
      railName
      supportedPositionIds
      unsupportedPositionIds
      supportedCount
      totalCount
      isFullySupported
      positionCountryRestrictions {
        positionId
        allowedCountryIds
      }
    }
  }
}
    `;

/**
 * __useAvailablePaymentRailsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentRailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentRailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentRailsQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      accountIds: // value for 'accountIds'
 *      paymentPrefIds: // value for 'paymentPrefIds'
 *      countryId: // value for 'countryId'
 *      isLpPortal: // value for 'isLpPortal'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useAvailablePaymentRailsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>(AvailablePaymentRailsDocument, options);
      }
export function useAvailablePaymentRailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>(AvailablePaymentRailsDocument, options);
        }
// @ts-ignore
export function useAvailablePaymentRailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>;
export function useAvailablePaymentRailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AvailablePaymentRailsQuery | undefined, GraphqlTypes.AvailablePaymentRailsQueryVariables>;
export function useAvailablePaymentRailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>(AvailablePaymentRailsDocument, options);
        }
export type AvailablePaymentRailsQueryHookResult = ReturnType<typeof useAvailablePaymentRailsQuery>;
export type AvailablePaymentRailsLazyQueryHookResult = ReturnType<typeof useAvailablePaymentRailsLazyQuery>;
export type AvailablePaymentRailsSuspenseQueryHookResult = ReturnType<typeof useAvailablePaymentRailsSuspenseQuery>;
export type AvailablePaymentRailsQueryResult = Apollo.QueryResult<GraphqlTypes.AvailablePaymentRailsQuery, GraphqlTypes.AvailablePaymentRailsQueryVariables>;
export const GetDetailedPaymentPrefDocument = gql`
    query GetDetailedPaymentPref($id: ID!) {
  paymentPrefs(paymentPrefIds: [$id]) {
    id
    ...DetailedPaymentPref
  }
}
    ${DetailedPaymentPrefFragmentDoc}`;

/**
 * __useGetDetailedPaymentPrefQuery__
 *
 * To run a query within a React component, call `useGetDetailedPaymentPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedPaymentPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedPaymentPrefQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetailedPaymentPrefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables> & ({ variables: GraphqlTypes.GetDetailedPaymentPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>(GetDetailedPaymentPrefDocument, options);
      }
export function useGetDetailedPaymentPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>(GetDetailedPaymentPrefDocument, options);
        }
// @ts-ignore
export function useGetDetailedPaymentPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>;
export function useGetDetailedPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetDetailedPaymentPrefQuery | undefined, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>;
export function useGetDetailedPaymentPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>(GetDetailedPaymentPrefDocument, options);
        }
export type GetDetailedPaymentPrefQueryHookResult = ReturnType<typeof useGetDetailedPaymentPrefQuery>;
export type GetDetailedPaymentPrefLazyQueryHookResult = ReturnType<typeof useGetDetailedPaymentPrefLazyQuery>;
export type GetDetailedPaymentPrefSuspenseQueryHookResult = ReturnType<typeof useGetDetailedPaymentPrefSuspenseQuery>;
export type GetDetailedPaymentPrefQueryResult = Apollo.QueryResult<GraphqlTypes.GetDetailedPaymentPrefQuery, GraphqlTypes.GetDetailedPaymentPrefQueryVariables>;
export const GetPaymentBatchesConnectionDocument = gql`
    query GetPaymentBatchesConnection($inputFilter: PaymentBatchesFilterInput!, $paginationArgs: PaginationArgs!, $isGPX: Boolean!) {
  paymentBatchesConnection(
    inputFilter: $inputFilter
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        id
        createdAt
        objectsCount
        status
        netAmount
        creatorId
        paymentDescription
        fundingPayment {
          id
          method
        }
        payments {
          objectId
          status
          method
          amount
          scheduledProcessDate
          position {
            id
            account {
              id
              name
            }
          }
        }
        arena {
          id
          name
          jsqHostname
        }
        entity {
          id
          name
        }
        bankAccount {
          id
          bankName
          bankInfoRedacted
          ownerName
        }
        referenceObject {
          ... on DistributionBatchObjectType {
            id
            description
            paymentsLabel
            paymentsSubtitleLabel
            __typename
          }
          ... on CapitalCallBatchObjectType {
            id
            description
            paymentsLabel
            __typename
          }
          ... on TransactionBatchObjectType {
            id
            description
            paymentsLabel
            paymentsSubtitleLabel
            __typename
          }
          ... on PayableObjectType {
            id
            payee {
              id
              name
              payeeType
            }
            __typename
          }
        }
        requiredApprovalCount @include(if: $isGPX)
        isDifferentApproverRequired @include(if: $isGPX)
        approvals @include(if: $isGPX) {
          id
          userId
          createdAt
        }
      }
      cursor
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetPaymentBatchesConnectionQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesConnectionQuery({
 *   variables: {
 *      inputFilter: // value for 'inputFilter'
 *      paginationArgs: // value for 'paginationArgs'
 *      isGPX: // value for 'isGPX'
 *   },
 * });
 */
export function useGetPaymentBatchesConnectionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>(GetPaymentBatchesConnectionDocument, options);
      }
export function useGetPaymentBatchesConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>(GetPaymentBatchesConnectionDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>;
export function useGetPaymentBatchesConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesConnectionQuery | undefined, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>;
export function useGetPaymentBatchesConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>(GetPaymentBatchesConnectionDocument, options);
        }
export type GetPaymentBatchesConnectionQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionQuery>;
export type GetPaymentBatchesConnectionLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionLazyQuery>;
export type GetPaymentBatchesConnectionSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionSuspenseQuery>;
export type GetPaymentBatchesConnectionQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesConnectionQuery, GraphqlTypes.GetPaymentBatchesConnectionQueryVariables>;
export const GetPaymentBatchesConnectionForExportDocument = gql`
    query GetPaymentBatchesConnectionForExport($inputFilter: PaymentBatchesFilterInput!, $paginationArgs: PaginationArgs!) {
  paymentBatchesConnection(
    inputFilter: $inputFilter
    paginationArgs: $paginationArgs
  ) {
    edges {
      node {
        id
        objectsCount
        status
        netAmount
        paymentDescription
        fundingPayment {
          id
          method
        }
        arena {
          id
          name
        }
        entity {
          id
          name
        }
        referenceObject {
          ... on DistributionBatchObjectType {
            id
            description
            paymentsLabel
            paymentsSubtitleLabel
            __typename
          }
          ... on CapitalCallBatchObjectType {
            id
            description
            paymentsLabel
            __typename
          }
          ... on TransactionBatchObjectType {
            id
            description
            paymentsLabel
            paymentsSubtitleLabel
            __typename
          }
          ... on PayableObjectType {
            id
            payee {
              id
              name
              payeeType
            }
            __typename
          }
        }
        payments {
          id
          objectId
          status
          method
          amount
          scheduledProcessDate
          position {
            id
            account {
              id
              name
            }
          }
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaymentBatchesConnectionForExportQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchesConnectionForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchesConnectionForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchesConnectionForExportQuery({
 *   variables: {
 *      inputFilter: // value for 'inputFilter'
 *      paginationArgs: // value for 'paginationArgs'
 *   },
 * });
 */
export function useGetPaymentBatchesConnectionForExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>(GetPaymentBatchesConnectionForExportDocument, options);
      }
export function useGetPaymentBatchesConnectionForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>(GetPaymentBatchesConnectionForExportDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchesConnectionForExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>;
export function useGetPaymentBatchesConnectionForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery | undefined, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>;
export function useGetPaymentBatchesConnectionForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>(GetPaymentBatchesConnectionForExportDocument, options);
        }
export type GetPaymentBatchesConnectionForExportQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionForExportQuery>;
export type GetPaymentBatchesConnectionForExportLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionForExportLazyQuery>;
export type GetPaymentBatchesConnectionForExportSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchesConnectionForExportSuspenseQuery>;
export type GetPaymentBatchesConnectionForExportQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchesConnectionForExportQuery, GraphqlTypes.GetPaymentBatchesConnectionForExportQueryVariables>;
export const ApproveCanopyPaymentBatchDocument = gql`
    mutation approveCanopyPaymentBatch($paymentBatchId: ID!) {
  approveCanopyPaymentBatch(
    approveCanopyPaymentBatchInput: {paymentBatchId: $paymentBatchId}
  ) {
    id
    status
  }
}
    `;
export type ApproveCanopyPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveCanopyPaymentBatchMutation, GraphqlTypes.ApproveCanopyPaymentBatchMutationVariables>;

/**
 * __useApproveCanopyPaymentBatchMutation__
 *
 * To run a mutation, you first call `useApproveCanopyPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCanopyPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCanopyPaymentBatchMutation, { data, loading, error }] = useApproveCanopyPaymentBatchMutation({
 *   variables: {
 *      paymentBatchId: // value for 'paymentBatchId'
 *   },
 * });
 */
export function useApproveCanopyPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveCanopyPaymentBatchMutation, GraphqlTypes.ApproveCanopyPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveCanopyPaymentBatchMutation, GraphqlTypes.ApproveCanopyPaymentBatchMutationVariables>(ApproveCanopyPaymentBatchDocument, options);
      }
export type ApproveCanopyPaymentBatchMutationHookResult = ReturnType<typeof useApproveCanopyPaymentBatchMutation>;
export type ApproveCanopyPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveCanopyPaymentBatchMutation>;
export type ApproveCanopyPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveCanopyPaymentBatchMutation, GraphqlTypes.ApproveCanopyPaymentBatchMutationVariables>;
export const DenyCanopyPaymentBatchDocument = gql`
    mutation denyCanopyPaymentBatch($paymentBatchId: String!, $reason: String!) {
  denyCanopyPaymentBatch(
    denyCanopyPaymentBatchInput: {paymentBatchId: $paymentBatchId, reason: $reason}
  ) {
    id
    status
  }
}
    `;
export type DenyCanopyPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.DenyCanopyPaymentBatchMutation, GraphqlTypes.DenyCanopyPaymentBatchMutationVariables>;

/**
 * __useDenyCanopyPaymentBatchMutation__
 *
 * To run a mutation, you first call `useDenyCanopyPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyCanopyPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyCanopyPaymentBatchMutation, { data, loading, error }] = useDenyCanopyPaymentBatchMutation({
 *   variables: {
 *      paymentBatchId: // value for 'paymentBatchId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyCanopyPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DenyCanopyPaymentBatchMutation, GraphqlTypes.DenyCanopyPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DenyCanopyPaymentBatchMutation, GraphqlTypes.DenyCanopyPaymentBatchMutationVariables>(DenyCanopyPaymentBatchDocument, options);
      }
export type DenyCanopyPaymentBatchMutationHookResult = ReturnType<typeof useDenyCanopyPaymentBatchMutation>;
export type DenyCanopyPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.DenyCanopyPaymentBatchMutation>;
export type DenyCanopyPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DenyCanopyPaymentBatchMutation, GraphqlTypes.DenyCanopyPaymentBatchMutationVariables>;
export const ApproveGpxPaymentBatchDocument = gql`
    mutation approveGPXPaymentBatch($approvePaymentBatchInput: ApprovePaymentBatchInput!) {
  approvePaymentBatch(approvePaymentBatchInput: $approvePaymentBatchInput) {
    id
    status
    approvals {
      id
    }
    fundingPayment {
      id
      scheduledProcessDate
    }
  }
}
    `;
export type ApproveGpxPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveGpxPaymentBatchMutation, GraphqlTypes.ApproveGpxPaymentBatchMutationVariables>;

/**
 * __useApproveGpxPaymentBatchMutation__
 *
 * To run a mutation, you first call `useApproveGpxPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveGpxPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveGpxPaymentBatchMutation, { data, loading, error }] = useApproveGpxPaymentBatchMutation({
 *   variables: {
 *      approvePaymentBatchInput: // value for 'approvePaymentBatchInput'
 *   },
 * });
 */
export function useApproveGpxPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveGpxPaymentBatchMutation, GraphqlTypes.ApproveGpxPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveGpxPaymentBatchMutation, GraphqlTypes.ApproveGpxPaymentBatchMutationVariables>(ApproveGpxPaymentBatchDocument, options);
      }
export type ApproveGpxPaymentBatchMutationHookResult = ReturnType<typeof useApproveGpxPaymentBatchMutation>;
export type ApproveGpxPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveGpxPaymentBatchMutation>;
export type ApproveGpxPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveGpxPaymentBatchMutation, GraphqlTypes.ApproveGpxPaymentBatchMutationVariables>;
export const DenyGpxPaymentBatchDocument = gql`
    mutation denyGPXPaymentBatch($paymentBatchId: String!, $reason: String!) {
  denyPaymentBatch(
    denyPaymentBatchInput: {paymentBatchId: $paymentBatchId, reason: $reason}
  ) {
    id
    status
  }
}
    `;
export type DenyGpxPaymentBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.DenyGpxPaymentBatchMutation, GraphqlTypes.DenyGpxPaymentBatchMutationVariables>;

/**
 * __useDenyGpxPaymentBatchMutation__
 *
 * To run a mutation, you first call `useDenyGpxPaymentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyGpxPaymentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyGpxPaymentBatchMutation, { data, loading, error }] = useDenyGpxPaymentBatchMutation({
 *   variables: {
 *      paymentBatchId: // value for 'paymentBatchId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyGpxPaymentBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DenyGpxPaymentBatchMutation, GraphqlTypes.DenyGpxPaymentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DenyGpxPaymentBatchMutation, GraphqlTypes.DenyGpxPaymentBatchMutationVariables>(DenyGpxPaymentBatchDocument, options);
      }
export type DenyGpxPaymentBatchMutationHookResult = ReturnType<typeof useDenyGpxPaymentBatchMutation>;
export type DenyGpxPaymentBatchMutationResult = Apollo.MutationResult<GraphqlTypes.DenyGpxPaymentBatchMutation>;
export type DenyGpxPaymentBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DenyGpxPaymentBatchMutation, GraphqlTypes.DenyGpxPaymentBatchMutationVariables>;
export const GetPaymentBatchLogsDocument = gql`
    query GetPaymentBatchLogs($paymentBatchId: ID!) {
  paymentBatch(id: $paymentBatchId) {
    id
    logs {
      ...DetailedPaymentBatchLog
    }
  }
}
    ${DetailedPaymentBatchLogFragmentDoc}`;

/**
 * __useGetPaymentBatchLogsQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchLogsQuery({
 *   variables: {
 *      paymentBatchId: // value for 'paymentBatchId'
 *   },
 * });
 */
export function useGetPaymentBatchLogsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>(GetPaymentBatchLogsDocument, options);
      }
export function useGetPaymentBatchLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>(GetPaymentBatchLogsDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>;
export function useGetPaymentBatchLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchLogsQuery | undefined, GraphqlTypes.GetPaymentBatchLogsQueryVariables>;
export function useGetPaymentBatchLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>(GetPaymentBatchLogsDocument, options);
        }
export type GetPaymentBatchLogsQueryHookResult = ReturnType<typeof useGetPaymentBatchLogsQuery>;
export type GetPaymentBatchLogsLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchLogsLazyQuery>;
export type GetPaymentBatchLogsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchLogsSuspenseQuery>;
export type GetPaymentBatchLogsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchLogsQuery, GraphqlTypes.GetPaymentBatchLogsQueryVariables>;
export const GetPaymentBatchDetailDocument = gql`
    query GetPaymentBatchDetail($id: ID!, $isGPX: Boolean = false) {
  paymentBatch(id: $id) {
    id
    objectType
    createdAt
    objectsCount
    status
    netAmount
    creatorId
    paymentDescription
    makerNote
    requiredApprovalCount @include(if: $isGPX)
    isDifferentApproverRequired @include(if: $isGPX)
    approvals @include(if: $isGPX) {
      id
      createdAt
      userId
      reason
    }
    fundingPayment {
      id
      method
      scheduledProcessDate
    }
    payments {
      id
      objectId
      status
      method
      amount
      scheduledProcessDate
      referenceNumber
      failureReason
      failedAt
      returnCode
      returnReason
      position {
        id
        account {
          id
          name
        }
      }
    }
    arena {
      id
      name
      jsqHostname
    }
    entity {
      id
      name
    }
    bankAccount {
      id
      bankName
      bankInfoRedacted
      ownerName
    }
    referenceObject {
      ... on DistributionBatchObjectType {
        id
        description
        distributionCount
        paymentsLabel
        paymentsSubtitleLabel
        requestedPaymentDate
        __typename
      }
      ... on CapitalCallBatchObjectType {
        id
        description
        paymentsLabel
        paymentsSubtitleLabel
        requestedPaymentDate
        __typename
      }
      ... on TransactionBatchObjectType {
        id
        description
        paymentsLabel
        paymentsSubtitleLabel
        requestedPaymentDate
        __typename
      }
      ... on PayableObjectType {
        id
        invoiceNumber
        invoiceDate
        dueDate
        amount
        payee {
          id
          name
          payeeType
          status
          paymentPref {
            watchlistStatus {
              id
              status
            }
          }
        }
        supportingDocuments {
          id
          name
          viewUrl
        }
        __typename
      }
    }
  }
}
    `;

/**
 * __useGetPaymentBatchDetailQuery__
 *
 * To run a query within a React component, call `useGetPaymentBatchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentBatchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentBatchDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isGPX: // value for 'isGPX'
 *   },
 * });
 */
export function useGetPaymentBatchDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables> & ({ variables: GraphqlTypes.GetPaymentBatchDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>(GetPaymentBatchDetailDocument, options);
      }
export function useGetPaymentBatchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>(GetPaymentBatchDetailDocument, options);
        }
// @ts-ignore
export function useGetPaymentBatchDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>;
export function useGetPaymentBatchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPaymentBatchDetailQuery | undefined, GraphqlTypes.GetPaymentBatchDetailQueryVariables>;
export function useGetPaymentBatchDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>(GetPaymentBatchDetailDocument, options);
        }
export type GetPaymentBatchDetailQueryHookResult = ReturnType<typeof useGetPaymentBatchDetailQuery>;
export type GetPaymentBatchDetailLazyQueryHookResult = ReturnType<typeof useGetPaymentBatchDetailLazyQuery>;
export type GetPaymentBatchDetailSuspenseQueryHookResult = ReturnType<typeof useGetPaymentBatchDetailSuspenseQuery>;
export type GetPaymentBatchDetailQueryResult = Apollo.QueryResult<GraphqlTypes.GetPaymentBatchDetailQuery, GraphqlTypes.GetPaymentBatchDetailQueryVariables>;
export const MarkPaymentAsFailedDocument = gql`
    mutation MarkPaymentAsFailed($markPaymentAsFailedInput: MarkPaymentAsFailedInput!) {
  markPaymentAsFailed(markPaymentAsFailedInput: $markPaymentAsFailedInput) {
    id
    status
    failureReason
    failedAt
  }
}
    `;
export type MarkPaymentAsFailedMutationFn = Apollo.MutationFunction<GraphqlTypes.MarkPaymentAsFailedMutation, GraphqlTypes.MarkPaymentAsFailedMutationVariables>;

/**
 * __useMarkPaymentAsFailedMutation__
 *
 * To run a mutation, you first call `useMarkPaymentAsFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPaymentAsFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPaymentAsFailedMutation, { data, loading, error }] = useMarkPaymentAsFailedMutation({
 *   variables: {
 *      markPaymentAsFailedInput: // value for 'markPaymentAsFailedInput'
 *   },
 * });
 */
export function useMarkPaymentAsFailedMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.MarkPaymentAsFailedMutation, GraphqlTypes.MarkPaymentAsFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.MarkPaymentAsFailedMutation, GraphqlTypes.MarkPaymentAsFailedMutationVariables>(MarkPaymentAsFailedDocument, options);
      }
export type MarkPaymentAsFailedMutationHookResult = ReturnType<typeof useMarkPaymentAsFailedMutation>;
export type MarkPaymentAsFailedMutationResult = Apollo.MutationResult<GraphqlTypes.MarkPaymentAsFailedMutation>;
export type MarkPaymentAsFailedMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.MarkPaymentAsFailedMutation, GraphqlTypes.MarkPaymentAsFailedMutationVariables>;
export const GetPositionDetailsDocument = gql`
    query GetPositionDetails($paymentBatchId: ID!) {
  paymentBatch(id: $paymentBatchId) {
    objectId
    status
    payments {
      id
      objectId
      status
      referenceNumber
      returnCode
      returnReason
      failureReason
      failedAt
      paymentPref {
        id
        bankInfoRedacted
      }
      position {
        id
        account {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPositionDetailsQuery__
 *
 * To run a query within a React component, call `useGetPositionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionDetailsQuery({
 *   variables: {
 *      paymentBatchId: // value for 'paymentBatchId'
 *   },
 * });
 */
export function useGetPositionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables> & ({ variables: GraphqlTypes.GetPositionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>(GetPositionDetailsDocument, options);
      }
export function useGetPositionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>(GetPositionDetailsDocument, options);
        }
// @ts-ignore
export function useGetPositionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>;
export function useGetPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetPositionDetailsQuery | undefined, GraphqlTypes.GetPositionDetailsQueryVariables>;
export function useGetPositionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>(GetPositionDetailsDocument, options);
        }
export type GetPositionDetailsQueryHookResult = ReturnType<typeof useGetPositionDetailsQuery>;
export type GetPositionDetailsLazyQueryHookResult = ReturnType<typeof useGetPositionDetailsLazyQuery>;
export type GetPositionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPositionDetailsSuspenseQuery>;
export type GetPositionDetailsQueryResult = Apollo.QueryResult<GraphqlTypes.GetPositionDetailsQuery, GraphqlTypes.GetPositionDetailsQueryVariables>;
export const GetAccountingPayablesDocument = gql`
    query GetAccountingPayables($filters: AccountingPayableFilters, $sort: AccountingPayableSort, $first: Int!, $after: String) {
  accountingPayables(filters: $filters, sort: $sort, first: $first, after: $after) {
    edges {
      node {
        id
        objectType
        label
        subtitleLabel
        description
        totalAmountPayable {
          monies
        }
        amountMarkedPaid {
          monies
        }
        date
        arena {
          id
          name
        }
        entity {
          id
          name
        }
        isPaymentRequested
        requestedPaymentDate
        payeeCount
        payees {
          position {
            account {
              name
            }
          }
        }
        amountPaidViaAutomatedPayments
        paymentBatches(filter: {batchStatus: [READY_FOR_TREASURY_REVIEW]}) {
          id
          status
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    count
  }
}
    `;

/**
 * __useGetAccountingPayablesQuery__
 *
 * To run a query within a React component, call `useGetAccountingPayablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingPayablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingPayablesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAccountingPayablesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables> & ({ variables: GraphqlTypes.GetAccountingPayablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>(GetAccountingPayablesDocument, options);
      }
export function useGetAccountingPayablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>(GetAccountingPayablesDocument, options);
        }
// @ts-ignore
export function useGetAccountingPayablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>;
export function useGetAccountingPayablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetAccountingPayablesQuery | undefined, GraphqlTypes.GetAccountingPayablesQueryVariables>;
export function useGetAccountingPayablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>(GetAccountingPayablesDocument, options);
        }
export type GetAccountingPayablesQueryHookResult = ReturnType<typeof useGetAccountingPayablesQuery>;
export type GetAccountingPayablesLazyQueryHookResult = ReturnType<typeof useGetAccountingPayablesLazyQuery>;
export type GetAccountingPayablesSuspenseQueryHookResult = ReturnType<typeof useGetAccountingPayablesSuspenseQuery>;
export type GetAccountingPayablesQueryResult = Apollo.QueryResult<GraphqlTypes.GetAccountingPayablesQuery, GraphqlTypes.GetAccountingPayablesQueryVariables>;